import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import moment from "moment-timezone";

import { useParams, Link, useLocation, useNavigate } from "react-router-dom";
import config from "../../../config/config";
import Loader from "../../../components/Loader/Loader";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import jsPDF from "jspdf";
import JsBarcode from "jsbarcode";
import html2pdf from "html2pdf.js";
import html2canvas from "html2canvas";
import { toastError, toastSuccess } from "../../../common/Toast";
import { DATA_EXPORT, ERROR_MESSAGE } from "../../../common/Constant";
import * as XLSX from "xlsx";
import DemoPic from "../../../assets/img/download.png";
import { decryptAndExtractId } from "../../../common/common";
import { checkUserPermission } from "../../../common/UserPermission";
import { red } from "@mui/material/colors";
import { error } from "jquery";
// import '../../../assets/scss/layout/header.scss';

const ShowLastSaleReceipt = ({ ecomreceipt = false }) => {
  let PERMISSION_SHOW_COST_PRICE = "show-cost-price";
  let navigate = useNavigate();
  const token = localStorage.getItem("Token");
  const [formValues, setFormValues] = useState([]);
  const [responseData, setResponseData] = useState([]);
  const [createddata, setcreateddate] = useState("");
  const [ModifiedDate, setModifiedDate] = useState("");
  const [CustomerOverDue, setCustomerOverDue] = useState("");
  const [loading, setLoading] = useState(false);
  const [totalSum, setTotalSum] = useState(0);
  const [selectedId, setSelectedId] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [salesItem, setSalesItem] = useState([]);
  const [showHeader, setShowHeader] = useState(false);

  console.log(
    responseData,
    "responseData1542222"
  );
  let sumss = 0;
  for (let i = 0; i < salesItem.length; i++) {
    const quantity = salesItem[i]?.Quantitypurchased
      ? Number(salesItem[i].Quantitypurchased)
      : 0;
    sumss += quantity;
  }

  console.log(
    responseData?.SalesDetails &&
      responseData?.SalesDetails?.Discountentiresale > 0,
    "100000000000"
  );
  console.log(responseData, "1>");
  // console.log(responseData?.CustomerDetails[0]?.personid, "1>");

  const [salesdetails, setSalesDetails] = useState([]);
  // console.log(salesdetails[0]?.CreatedName, "55814");
  // console.log(salesdetails[0]?.CreatedName.split(" ")[0], "55814");

  // console.log(salesdetails[0]?.Total, "5581121214");

  const DueAmount = Number(salesdetails[0]?.Total) + Number(CustomerOverDue);

  const [SalesDeliveryDetails, setSalesDeliveryDetails] = useState([]);
  const [headerData, setHeaderData] = useState({});
  const [headerDatas, setHeaderDatas] = useState([]);
  console.log(headerDatas, "987");

  const [itemData, setItemData] = useState([]);
  let sumss1 = 0;
  for (let i = 0; i < itemData.length; i++) {
    const quantity1 = itemData[i]?.Quantitypurchased
      ? Number(salesItem[i].Quantitypurchased)
      : 0;
    sumss1 += quantity1;
  }
  const [buttonPrintLable, setbuttonPrintLable] = useState(false);

  console.log(itemData, "410501");

  const barcodeRefs = useRef([]);
  let index = 0;
  const [data, setData] = useState({
    inputValue: "",
    width: 1,
    height: 20,
    fontSize: 15,
    zeroFill: 10,
  });

  const [paramObject, setParamObject] = useState({});

  let location = useLocation();

  const FromSaleID = useParams();

  console.log(location.pathname.split("/"), "location31052024");

  // console.log(responseData.SalesDetails.length > 0 ? 1 : 0 , "responseData.SalesDetails")

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const cValue = searchParams.has("i") ? searchParams.get("i") : null;

    console.log(cValue, "1022");

    let decryptedString = "";
    // const decryptedString = decryptAndConvert(cValue);
    if (location.pathname.split("/")[1] !== "sales-receipt") {
      decryptedString = decryptAndExtractId(cValue);
    }

    if (
      location.pathname.split("/")[1] === "ecominvoice" ||
      location.pathname.split("/")[1] === "ecompendingincoice"
    ) {
      console.log(decryptedString, "10052024");
      setParamObject({
        id: decryptedString,
      });
    } else if (
      location.pathname.split("/")[1] === "sales-receipt" &&
      location.pathname.split("/")?.length >= 3
    ) {
      setParamObject({
        id: FromSaleID?.id,
      });
    } else if (location.pathname.split("/")[1] === "ecomcustominvoice") {
      console.log(searchParams.get("type"), "8547");

      const type = searchParams.has("type") ? searchParams.get("type") : null;
      if (type !== "CustomerCustomInvoice") {
        navigate("/404");
      }
      setParamObject({
        id: decryptedString,
        type: type,
      });
    } else if (
      location.pathname.split("/")?.length === 2 &&
      location.pathname.split("/")[1] === "sales-receipt" // || location.pathname.split("/")[2] === "latest-receipt"
    ) {
      setParamObject({
        id: 0,
      });
    }
  }, []);

  const ITEMS_PER_PAGE = 20;
  console.log(itemData, "itemData 123");
  console.log(headerData, "headerData 123");

  //Function to generate barcode
  const generateBarcodes = () => {
    barcodeRefs.current.forEach((barcodeRef, index) => {
      console.log("barcodeRefs", barcodeRefs);
      var g = document.getElementsByTagName(barcodeRef);
      const barcodeValue = paramObject.id;
      console.log("barcodeValue", barcodeValue);
      const paddedBarcodeValue = barcodeValue.padStart(data.zeroFill, "0");
      JsBarcode(barcodeRef, paddedBarcodeValue, {
        width: data.width,
        height: data.height,
        fontSize: data.fontSize,
        displayValue: true,
        fontoptions: "bold",
        textAlign: "center",
        font: "monospace",
        textPosition: "bottom",
        textMargin: 2,
        margin: 10,
        marginTop: undefined,
        marginBottom: undefined,
        marginLeft: undefined,
        marginRight: undefined,
        format: "CODE128",
        valid: () => true,
        background: "#ffffff",
        lineColor: "#000000",
        padding: data.zeroFill,
      });
    });
  };

  //Function for downloading pdf of barcodesheet
  const downloadPdf = (e) => {
    e.preventDefault();
    setCurrentPage(1);
    const pdf = new jsPDF();
    responseData.SalesItems?.forEach((item) => {
      // Generate barcode for the current item
      const barcodeRef = barcodeRefs.current[item.SaleId];
      const barcodeValue = `${item.SaleId}`;
      const paddedBarcodeValue = barcodeValue.padStart(data.zeroFill, "0");
      JsBarcode(barcodeRef, paddedBarcodeValue, {
        // barcode options
      });

      // Add barcode to PDF
      const canvas = barcodeRef;
      const imgData = canvas.toDataURL("image/png");
      pdf.addImage(imgData, "PNG", 10, 10);
      pdf.addPage();
    });
    pdf.deletePage(responseData.SalesItems?.length + 1); // Remove extra page added by addPage() method
    pdf.save("barcodes.pdf");
  };

  console.log("salesItem 95", salesItem);

  const handlePrint = (e) => {
    e.preventDefault();
    let headerElement = document.querySelector("#header");
    let header1Element = document.querySelector("#header1");
    let footerElement = document.getElementById("footer");
    let TotalfooterElement = document.getElementById("Totalfooter");

    // Ensure that header elements exist
    if (!headerElement || !header1Element) {
      console.error("Header or Header1 element is missing.");
      return;
    }

    // Styling the footer elements
    footerElement.style.padding = "0 20px";
    footerElement.style.marginTop = "25px";

    // Assuming some response data with sales items
    const discountEntireSale = Number(
      responseData?.SalesItems[0]?.Discountpercent || "[]"
    );
    const showDiscountColumn = discountEntireSale > 0;
    const salesItems = responseData?.SalesItems || [];
    const itemsPerPage = 18;
    const firstPageItemsCount = 13;
    const specialFirstPageItemsCount = 8;
    const totalItems = responseData.length;
    let carryOverSum = 0;
    let currentIndex = 1;

    console.log(salesItems, "salesItemscooooooooooo123");

    // Modified chunking function to handle special case for first page
    const chunkArray = (array, specialCase) => {
      const chunks = [];
      if (specialCase) {
        if (array.length > specialFirstPageItemsCount) {
          chunks.push(array.slice(0, specialFirstPageItemsCount));
          chunks.push(array.slice(specialFirstPageItemsCount));
        } else {
          chunks.push(array);
        }
      } else {
        if (array.length > 0) {
          chunks.push(array.slice(0, firstPageItemsCount));
        }
        for (let i = firstPageItemsCount; i < array.length; i += itemsPerPage) {
          chunks.push(array.slice(i, i + itemsPerPage));
        }
      }
      return chunks;
    };

    const chunks = chunkArray(salesItems, totalItems >= 7 && totalItems <= 14);

    // Create a container for the pages
    let printContainer = document.createElement("div");

    chunks.forEach((chunk, pageIndex) => {
      // Create a new page for each chunk
      let page = document.createElement("div");
      page.style.padding = "0 20px";
      page.style.pageBreakAfter = "always";

      // Append either header or header1 depending on the page index
      if (pageIndex === 0) {
        page.appendChild(headerElement.cloneNode(true));
      } else {
        page.appendChild(header1Element.cloneNode(true));
      }

      // Create a new table for the chunk
      let table = document.createElement("table");
      table.className = "table mt-1";
      table.style.width = "100%";
      table.style.tableLayout = "fixed";
      table.style.marginBottom = "10px";
      table.style.fontSize = "5px";
      table.style.borderCollapse = "collapse";

      let thead = document.createElement("thead");
      thead.innerHTML = `
        <tr>
          <th style="width: 10%; background-color: #1a2649; color: #ffffff; padding: 7px;">#</th>
          ${
            showDiscountColumn
              ? `<th style="width: 30%; background-color: #1a2649; color: #ffffff; padding: 7px;">Product/Services</th>`
              : `<th style="width: 35%; background-color: #1a2649; color: #ffffff; padding: 7px;">Product/Services</th>`
          }
         ${
           showDiscountColumn
             ? ` <th style="width: 15%; background-color: #1a2649; color: #ffffff; text-align: right; padding: 7px;">Quantity</th>`
             : ` <th style="width: 20%; background-color: #1a2649; color: #ffffff; text-align: right; padding: 7px;">Quantity</th>`
         }
         ${
           showDiscountColumn
             ? ` <th style="width: 15%; background-color: #1a2649; color: #ffffff; text-align: right; padding: 7px;">Price</th>`
             : ` <th style="width: 20%; background-color: #1a2649; color: #ffffff; text-align: right; padding: 7px;">Price</th>`
         }
          ${
            showDiscountColumn
              ? `<th style="width: 15%; background-color: #1a2649; color: #ffffff; text-align: right; padding: 7px;">Discount %</th>`
              : ``
          }
          <th style="width: 15%; background-color: #1a2649; color: #ffffff; text-align: right; padding: 7px;">Total</th>
        </tr>`;

      let tbody = document.createElement("tbody");

      chunk.forEach((item, index) => {
        let row = document.createElement("tr");
        row.style.padding = "2px";

        const itemTotal = Number(item.Total);
        carryOverSum += itemTotal;

        row.innerHTML = `
          <td style="padding: 2px;">${currentIndex++}</td>
          <td style="text-align: left; padding: 2px; color: black;">${
            buttonPrintLable === false
              ? item.ItemVariationName || item.ItemName
              : item.ItemVariationPrintName ||
                item.ItemVariationName ||
                item.ItemName
          }</td>
          <td style="text-align: right; padding: 2px;"></td>
          <td style="text-align: right; padding: 2px;"></td>
          <td style="text-align: right; padding: 2px;"></td>
          <td style="text-align: right; padding: 2px;"></td>
        `;

        let detailsRow = document.createElement("tr");
        detailsRow.style.padding = "2px";
        detailsRow.style.borderBottom = "0.1px solid #dcdcdc";

        detailsRow.innerHTML = `
          <td style="padding: 2px;"></td>
          <td style="text-align: left; padding: 2px; color: black;"></td>
           <td style="text-align: right; padding: 2px; color: black;">${Number(
             item.Quantitypurchased
           ).toLocaleString("en-US", {
             minimumFractionDigits: 2,
             maximumFractionDigits: 2,
           })}</td>
          <td style="text-align: right; padding: 2px; color: black;">$ ${Number(
            item.Itemunitprice
          ).toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}</td>
         ${
           discountEntireSale
             ? ` <td style="text-align: right; padding: 2px; color: black;">${Number(
                 item.Discountpercent
               ).toLocaleString("en-US", {
                 minimumFractionDigits: 2,
                 maximumFractionDigits: 2,
               })}</td>`
             : ``
         }
          <td style="text-align: right; padding: 2px; color: black;">$ ${itemTotal.toLocaleString(
            "en-US",
            { minimumFractionDigits: 2, maximumFractionDigits: 2 }
          )}</td>
        `;

        tbody.appendChild(row);
        tbody.appendChild(detailsRow);
      });

      table.appendChild(thead);
      table.appendChild(tbody);

      let tfoot = document.createElement("tfoot");
      tfoot.innerHTML = `
       ${
         showDiscountColumn
           ? `     <tr>
             <td colspan="2" style="text-align: right; padding: 2px; margin-top: -12px;">
              Page ${pageIndex + 1} of ${chunks.length}
            </td>
              <td colspan="3" style="text-align: right; padding: 2px;"><strong>Carry Over:</strong></td>
              <td style="text-align: right; padding: 2px; color: black;">$ ${carryOverSum.toLocaleString(
                "en-US",
                { minimumFractionDigits: 2, maximumFractionDigits: 2 }
              )}</td>
            </tr>`
           : `     <tr>
           <td colspan="2" style="text-align: right; padding: 2px; margin-top: -12px;">
            Page ${pageIndex + 1} of ${
               pageIndex + 1 == chunks.length && chunk.length > 11
                 ? chunks.length + 1
                 : chunks.length
             } 
          </td>
            <td colspan="2" style="text-align: right; padding: 2px;"><strong>Carry Over:</strong></td>
            <td style="text-align: right; padding: 2px; color: black;">$ ${carryOverSum.toLocaleString(
              "en-US",
              { minimumFractionDigits: 2, maximumFractionDigits: 2 }
            )}</td>
          </tr>`
       }
      `;

      table.appendChild(tfoot);
      page.appendChild(table);

      // Append the page to the print container
      printContainer.appendChild(page);

      // Add a page break and the footer on a new page if the last chunk has more than 7 items
      if (pageIndex === chunks.length - 1) {
        page.appendChild(TotalfooterElement.cloneNode(true));
        if (chunk.length > 11) {
          // Add a new page for the footer if the last chunk has more than 7 items
          let footerPage = document.createElement("div");
          footerPage.appendChild(footerElement.cloneNode(true));
          if (pageIndex + 1 == chunks.length) {
            let tfoots = document.createElement("tfoot");
            tfoots.innerHTML = `
            <tr colspan="3" style="text-align: right; padding: 2px;> 
            <td colspan="3" style="text-align: right; padding: 2px; margin-top: -12px;">
                <td colspan="3" style="text-align: right; padding: 2px; margin-top: -12px;"> Page ${
                  pageIndex + 2
                } of ${chunks.length + 1} </td>   
              </td>
            </tr>
  
            `;

            footerPage.appendChild(tfoots);
          }

          printContainer.appendChild(footerPage);
        } else {
          // Append footer on the same page if the last chunk has 7 or fewer items
          page.appendChild(footerElement.cloneNode(true));
        }
      }
    });

    // Detect if it's a mobile device or a desktop
    const isMobile = window.innerWidth <= 768;

    // Generate the PDF and open it in a new window for preview
    setTimeout(() => {
      const opt = {
        margin: 0.2,
        filename: `#${salesdetails[0]?.Posid} - ${
          responseData?.CustomerDetails[0]?.Companyname || ""
        } Invoice.pdf`, //"ReceivingInvoice.pdf",
        html2canvas: { scale: 5 }, // Increase the scale for better resolution
        jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
      };
      html2pdf()
        .from(printContainer)
        .set(opt)
        .output("blob")
        .then((pdfBlob) => {
          const pdfUrl = URL.createObjectURL(pdfBlob); // Create a URL for the Blob
          window.open(pdfUrl, "_blank"); // Open the PDF in a new tab
        })
        .catch((err) => {
          console.error("Error generating PDF:", err);
        });
    }, 50);
  };

  const handleDownload = (e) => {
    e.preventDefault();
    // Selecting the required DOM elements
    let headerElement = document.querySelector("#header");
    let header1Element = document.querySelector("#header1");
    let footerElement = document.getElementById("footer");
    let TotalfooterElement = document.getElementById("Totalfooter");

    // Ensure that header elements exist
    if (!headerElement || !header1Element) {
      console.error("Header or Header1 element is missing.");
      return;
    }

    // Styling the footer elements
    footerElement.style.padding = "0 20px";
    footerElement.style.marginTop = "25px";

    // Assuming some response data with sales items
    const discountEntireSale = Number(
      responseData?.SalesItems[0]?.Discountpercent || "[]"
    );
    const showDiscountColumn = discountEntireSale > 0;
    const salesItems = responseData?.SalesItems || [];
    const itemsPerPage = 19;
    const firstPageItemsCount = 13;
    const specialFirstPageItemsCount = 8;
    const totalItems = salesItems.length;
    let carryOverSum = 0;
    let currentIndex = 1;

    console.log(salesItems, "salesItemscooooooooooo123");

    // Modified chunking function to handle special case for first page
    const chunkArray = (array, specialCase) => {
      const chunks = [];
      if (specialCase) {
        if (array.length > specialFirstPageItemsCount) {
          chunks.push(array.slice(0, specialFirstPageItemsCount));
          chunks.push(array.slice(specialFirstPageItemsCount));
        } else {
          chunks.push(array);
        }
      } else {
        if (array.length > 0) {
          chunks.push(array.slice(0, firstPageItemsCount));
        }
        for (let i = firstPageItemsCount; i < array.length; i += itemsPerPage) {
          chunks.push(array.slice(i, i + itemsPerPage));
        }
      }
      return chunks;
    };

    const chunks = chunkArray(salesItems, totalItems >= 7 && totalItems <= 14);

    // Create a container for the pages
    let printContainer = document.createElement("div");

    chunks.forEach((chunk, pageIndex) => {
      // Create a new page for each chunk
      let page = document.createElement("div");
      page.style.padding = "0 20px";
      page.style.pageBreakAfter = "always";

      // Append either header or header1 depending on the page index
      if (pageIndex === 0) {
        page.appendChild(headerElement.cloneNode(true));
      } else {
        page.appendChild(header1Element.cloneNode(true));
      }

      // Create the table to hold the sales items
      let table = document.createElement("table");
      table.className = "table mt-1";
      table.style.width = "100%";
      table.style.tableLayout = "fixed";
      table.style.marginBottom = "10px";
      table.style.fontSize = "5px";
      table.style.borderCollapse = "collapse";
      table.style.marginTop = "80px";

      // Table headers
      let thead = document.createElement("thead");
      thead.innerHTML = `
        <tr>
          <th style="width: 10%; background-color: #1a2649; color: #ffffff; padding: 7px; text-align: center">#</th>
          ${
            showDiscountColumn
              ? `<th style="width: 30%; background-color: #1a2649; color: #ffffff; padding: 7px;">Product/Services</th>`
              : `<th style="width: 35%; background-color: #1a2649; color: #ffffff; padding: 7px;">Product/Services</th>`
          }
          ${
            showDiscountColumn
              ? ` <th style="width: 15%; background-color: #1a2649; color: #ffffff; text-align: right; padding: 7px;">Quantity</th>`
              : ` <th style="width: 20%; background-color: #1a2649; color: #ffffff; text-align: right; padding: 7px;">Quantity</th>`
          }
          ${
            showDiscountColumn
              ? ` <th style="width: 15%; background-color: #1a2649; color: #ffffff; text-align: right; padding: 7px;">Price</th>`
              : ` <th style="width: 20%; background-color: #1a2649; color: #ffffff; text-align: right; padding: 7px;">Price</th>`
          }
          ${
            showDiscountColumn
              ? `<th style="width: 15%; background-color: #1a2649; color: #ffffff; text-align: right; padding: 7px;">Discount %</th>`
              : ``
          }
          <th style="width: 15%; background-color: #1a2649; color: #ffffff; text-align: right; padding: 7px;">Total</th>
        </tr>`;

      // Table body with the sales items
      let tbody = document.createElement("tbody");

      chunk.forEach((item, index) => {
        let row = document.createElement("tr");
        row.style.padding = "2px";

        const itemTotal = Number(item.Total);
        carryOverSum += itemTotal;

        row.innerHTML = `
          <td style="display: flex; justify-content: center; padding: 2px; color: black;">${currentIndex++}</td>
          <td style="text-align: left; padding: 2px; color: black;">${
            item.ItemVariationName || item.ItemName
          }</td>
          <td style="text-align: right; padding: 2px;"></td>
          <td style="text-align: right; padding: 2px;"></td>
          <td style="text-align: right; padding: 2px;"></td>
          <td style="text-align: right; padding: 2px;"></td>
        `;

        let detailsRow = document.createElement("tr");
        detailsRow.style.padding = "2px";
        detailsRow.style.borderBottom = "0.1px solid #dcdcdc";

        detailsRow.innerHTML = `
          <td style="padding: 2px;"></td>
          <td style="text-align: left; padding: 2px; color: black;"></td>
          <td style="text-align: right; padding: 2px; color: black;">${Number(
            item.Quantitypurchased
          ).toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}</td>
          <td style="text-align: right; padding: 2px; color: black;">$ ${Number(
            item.Itemunitprice
          ).toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}</td>
         ${
           discountEntireSale
             ? ` <td style="text-align: right; padding: 2px; color: black;">${Number(
                 item.Discountpercent
               ).toLocaleString("en-US", {
                 minimumFractionDigits: 2,
                 maximumFractionDigits: 2,
               })}</td>`
             : ``
         }
          <td style="text-align: right; padding: 2px; color: black;">$ ${itemTotal.toLocaleString(
            "en-US",
            { minimumFractionDigits: 2, maximumFractionDigits: 2 }
          )}</td>
        `;

        tbody.appendChild(row);
        tbody.appendChild(detailsRow);
      });

      table.appendChild(thead);
      table.appendChild(tbody);

      // Table footer to show the carryover
      let tfoot = document.createElement("tfoot");
      if (pageIndex < chunks.length - 1) {
        tfoot.innerHTML = `
         ${
           showDiscountColumn
             ? ` <tr>
               <td colspan="2" style="text-align: right; padding: 2px; margin-top: -12px;">
                Page ${pageIndex + 1} of ${chunks.length}
              </td>
                <td colspan="3" style="text-align: right; padding: 2px;"><strong>Carry Over:</strong></td>
                <td style="text-align: right; padding: 2px; color: black;">$ ${carryOverSum.toLocaleString(
                  "en-US",
                  { minimumFractionDigits: 2, maximumFractionDigits: 2 }
                )}</td>
              </tr>`
             : ` <tr>
             <td colspan="2" style="text-align: right; padding: 2px; margin-top: -12px;">
               Page ${pageIndex + 1} of ${
                 pageIndex + 1 == chunks.length && chunk.length > 11
                   ? chunks.length + 1
                   : chunks.length
               } 
            </td>
              <td colspan="2" style="text-align: right; padding: 2px;"><strong>Carry Over:</strong></td>
              <td style="text-align: right; padding: 2px; color: black;">$ ${carryOverSum.toLocaleString(
                "en-US",
                { minimumFractionDigits: 2, maximumFractionDigits: 2 }
              )}</td>
            </tr>`
         }
        `;
      } else {
        // Adding empty cells to maintain layout on the last page
        tfoot.innerHTML = `
          <tr>
            <td colspan="${
              showDiscountColumn ? 3 : 2
            }" style="text-align: right; padding: 2px; margin-top: -12px;">
              Page ${pageIndex + 1} of ${chunks.length}
            </td>
            ${
              showDiscountColumn
                ? `<td colspan="2" style="text-align: right; padding: 2px;">&nbsp;</td>
                   <td style="text-align: right; padding: 2px; color: black;">&nbsp;</td>`
                : `<td colspan="2" style="text-align: right; padding: 2px;">&nbsp;</td>
                   <td style="text-align: right; padding: 2px; color: black;">&nbsp;</td>`
            }
          </tr>
        `;
      }

      table.appendChild(tfoot);
      page.appendChild(table);

      printContainer.appendChild(page);

      // Appending the total footer and regular footer for the last page
      // if (pageIndex === chunks.length - 1) {
      //   page.appendChild(TotalfooterElement.cloneNode(true));
      //   if (chunk.length > 11) {
      //     let footerPage = document.createElement("div");
      //     footerPage.appendChild(footerElement.cloneNode(true));
      //     printContainer.appendChild(footerPage);
      //   } else {
      //     page.appendChild(footerElement.cloneNode(true));
      //   }
      // }

      if (pageIndex === chunks.length - 1) {
        page.appendChild(TotalfooterElement.cloneNode(true));
        if (chunk.length > 11) {
          // Add a new page for the footer if the last chunk has more than 7 items
          let footerPage = document.createElement("div");
          footerPage.appendChild(footerElement.cloneNode(true));
          if (pageIndex + 1 == chunks.length) {
            let tfoots = document.createElement("tfoot");
            tfoots.innerHTML = `
            <tr> 
            <td colspan="2" style="text-align: right; padding: 2px; margin-top: -12px;">
               <td colspan="3" style="text-align: right; padding: 2px;">  </td> Page ${
                 pageIndex + 2
               } of ${chunks.length + 1}
              </td>
            </tr>
  
            `;

            footerPage.appendChild(tfoots);
          }

          printContainer.appendChild(footerPage);
        } else {
          // Append footer on the same page if the last chunk has 7 or fewer items
          page.appendChild(footerElement.cloneNode(true));
        }
      }
    });

    // Delayed PDF generation for better rendering
    setTimeout(() => {
      const opt = {
        margin: 0.2,
        filename: `#${salesdetails[0]?.Posid} - ${
          responseData?.CustomerDetails[0]?.Companyname || ""
        } Invoice.pdf`, // "SaleInvoice.pdf",
        html2canvas: { scale: 4 }, // Increase the scale for better resolution
        jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
      };
      html2pdf()
        .from(printContainer)
        .set(opt)
        .save()
        .then((pdf) => {
          console.log("PDF data exported:", pdf);
        });
    }, 50);
  };

  // console.log(`#${salesdetails[0]?.Posid || ""} - ${responseData?.CustomerDetails[0]?.Companyname || ""}`, "salesreceipt54654654")

  const handlefullfilmentprintPrint = () => {
    // setLoading(true);

    // Add the header
    let headerElement = document.querySelector("#FullFillment");
    let footerElement = document.getElementById("footer");

    if (!headerElement) {
      console.error("Header element is missing.");
      return;
    }

    headerElement.style.marginTop = "35px";
    headerElement.style.height = "248px";
    headerElement.style.overflow = "hidden";

    if (footerElement) {
      footerElement.style.padding = "0 20px";
      footerElement.style.marginTop = "25px";
    }

    const itemsPerPage = 15;
    let currentIndex = 1;
    let carryOverSum = 0;

    // Function to split array into chunks
    const chunkArray = (array, chunkSize) => {
      const chunks = [];
      for (let i = 0; i < array.length; i += chunkSize) {
        chunks.push(array.slice(i, i + chunkSize));
      }
      return chunks;
    };

    const chunks = chunkArray(salesItem, itemsPerPage);

    // Create a container for the PDF content
    let printContainer = document.createElement("div");

    chunks.forEach((chunk, pageIndex) => {
      let page = document.createElement("div");
      page.style.padding = "0 20px";
      page.style.pageBreakAfter = "always";

      // Clone and append header
      page.appendChild(headerElement.cloneNode(true));

      // Create a new table for the chunk
      let table = document.createElement("table");
      table.className = "table mt-1";
      table.style.width = "100%";
      table.style.tableLayout = "fixed";
      table.style.marginBottom = "10px";
      table.style.fontSize = "5px";
      table.style.borderCollapse = "collapse";

      let thead = document.createElement("thead");
      thead.innerHTML = `
        <tr>
          <th style="width: 10%; background-color: #1a2649; color: #ffffff; padding: 7px;"></th>
          <th style="width: 10%; background-color: #1a2649; color: #ffffff; padding: 7px;">#</th>
          <th style="width: 60%; background-color: #1a2649; color: #ffffff; padding: 7px;">Product/Services</th>
           <th style="width: 20%; background-color: #1a2649; color: #ffffff; padding: 7px;text-align: right;">Quantity</th>
          <th style="width: 40%; background-color: #1a2649; color: #ffffff; text-align: right; padding: 7px;">Location</th>
        </tr>`;

      let tbody = document.createElement("tbody");

      chunk.forEach((item, index) => {
        let row = document.createElement("tr");
        row.style.padding = "2px";

        const itemTotal = Number(item.Total);
        carryOverSum += itemTotal;

        row.innerHTML = `
          <td rowspan="2" style="padding-left: 5px; align-content: center;"><input type="checkbox" name="select"></td>
          <td style="padding: 2px;">${currentIndex++}</td>
          <td style="text-align: left; padding: 2px;color:black;">${
            buttonPrintLable === false
              ? item.ItemVariationName || item.ItemName
              : item.ItemVariationPrintName ||
                item.ItemVariationName ||
                item.ItemName
          }</td>
             <td style="text-align: right; padding: 2px;"></td>
          <td style="text-align: right; padding: 2px;"></td>
        `;

        let detailsRow = document.createElement("tr");
        detailsRow.style.padding = "2px";

        let locationContent = "Location not defined";

        if (item.AisleName || item.Binname || item.Rackname || item.ShelfName) {
          locationContent = [
            item.AisleName,
            item.Binname,
            item.Rackname,
            item.ShelfName,
          ]
            .filter(Boolean)
            .join("/");
        }

        detailsRow.innerHTML = `
          <td style="text-align: left; padding: 2px;"></td>
          <td style="text-align: right; padding: 2px;"></td>
              <td style="text-align: right; padding: 2px;color:black;">${Number(
                item.Quantitypurchased
              ).toLocaleString("en-US", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}</td>
          <td style="text-align: right; padding: 2px;color:black;">${locationContent}</td>
        `;

        tbody.appendChild(row);
        tbody.appendChild(detailsRow);
      });

      table.appendChild(thead);
      table.appendChild(tbody);

      let tfoot = document.createElement("tfoot");
      // Add page number in a separate row
      let pageRow = document.createElement("tr");
      pageRow.innerHTML = `
        <td colspan="6" style="text-align: center; padding: 2px;">
          Page ${pageIndex + 1} of ${
        pageIndex + 1 == chunks.length && chunk.length > 11
          ? chunks.length + 1
          : chunks.length
      } 
        </td>
      `;

      tfoot.appendChild(pageRow);
      table.appendChild(tfoot);
      page.appendChild(table);

      // Append the page to the print container
      printContainer.appendChild(page);

      // Add a page break and the footer on a new page if the last chunk has more than 3 items
      if (pageIndex === chunks.length - 1) {
        if (chunk.length > 9 && footerElement) {
          // Add a new page for the footer if the last chunk has more than 7 items
          let footerPage = document.createElement("div");
          footerPage.appendChild(footerElement.cloneNode(true));
          if (pageIndex + 1 == chunks.length) {
            let tfoots = document.createElement("tfoot");
            tfoots.innerHTML = `
            <tr colspan="3" style="text-align: right; padding: 2px;> 
            <td colspan="3" style="text-align: right; padding: 2px; margin-top: -12px;">
                <td colspan="3" style="text-align: right; padding: 2px; margin-top: -12px;"> Page ${
                  pageIndex + 2
                } of ${chunks.length + 1} </td>   
              </td>
            </tr>
  
            `;

            footerPage.appendChild(tfoots);
          }

          printContainer.appendChild(footerPage);
        } else {
          // Append footer on the same page if the last chunk has 7 or fewer items
          page.appendChild(footerElement.cloneNode(true));
        }
      }
    });

    setLoading(false);
    // Generate the PDF after a short delay
    setTimeout(() => {
      const opt = {
        margin: 0.2,
        filename: `#${salesdetails[0]?.Posid} - ${
          responseData?.CustomerDetails[0]?.Companyname || ""
        } Invoice.pdf`, // "SaleInvoice.pdf",
        html2canvas: { scale: 4 }, // Increase the scale for better resolution
        jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
      };
      html2pdf()
        .from(printContainer)
        .set(opt)
        .save()
        .then((pdf) => {
          console.log("PDF data exported:", pdf);
        });
    }, 50);
  };

  const curencyconverter = (value) => {
    console.log(value, "111");

    return value.toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };
  //Function for download

  // pdf download

  const handleCustomInvoicePrint = (e) => {
    e.preventDefault();
    // setLoading(true);
    let headerElement = document.querySelector("#custominvoiceheader");
    // let header1Element = document.querySelector("#header1");
    let footerElement = document.getElementById("footer");
    let TotalfooterElement = document.getElementById("customTotalfooter3");


     // Styling the footer elements
     footerElement.style.padding = "0 20px";
     footerElement.style.marginTop = "25px";

    const discountEntireSale = Number(itemData?.Discount || "[]");

    console.log(discountEntireSale, "book123");

    const showDiscountColumn = discountEntireSale > 0;
    const salesItems = itemData || [];
    const itemsPerPage = 18;
    const firstPageItemsCount = 13;
    const specialFirstPageItemsCount = 8;
    const totalItems = itemData.length;
    let carryOverSum = 0;
    let currentIndex = 1;


    console.log(showDiscountColumn, "book55555");

    if (!headerElement) {
      console.error("Header element is missing.");
      return;
    }

   
    const chunkArray = (array, specialCase) => {
      const chunks = [];
      if (specialCase) {
        if (array.length > specialFirstPageItemsCount) {
          chunks.push(array.slice(0, specialFirstPageItemsCount));
          chunks.push(array.slice(specialFirstPageItemsCount));
        } else {
          chunks.push(array);
        }
      } else {
        if (array.length > 0) {
          chunks.push(array.slice(0, firstPageItemsCount));
        }
        for (let i = firstPageItemsCount; i < array.length; i += itemsPerPage) {
          chunks.push(array.slice(i, i + itemsPerPage));
        }
      }
      return chunks;
    };

    const chunks = chunkArray(itemData, totalItems >= 7 && totalItems <= 14);


    let printContainer = document.createElement("div");

    chunks.forEach((chunk, pageIndex) => {
      let page = document.createElement("div");
      page.style.padding = "0 20px";
      page.style.pageBreakAfter = "always";

      // Append either header or header1 depending on the page index
      if (pageIndex === 0) {
        page.appendChild(headerElement.cloneNode(true));
      } else {
      //  page.appendChild(header1Element.cloneNode(true));
      }

      // Create a new table for the chunk
      let table = document.createElement("table");
      table.className = "table mt-1";
      table.style.width = "100%";
      table.style.tableLayout = "fixed";
      table.style.marginBottom = "10px";
      table.style.fontSize = "5px";
      table.style.borderCollapse = "collapse";

      let thead = document.createElement("thead");
      thead.innerHTML = `
        <tr>
          <th style="width: 10%; background-color: #1a2649; color: #ffffff; padding: 7px;">#</th>
          ${
            showDiscountColumn
              ? `<th style="width: 30%; background-color: #1a2649; color: #ffffff; padding: 7px;">Product/Services</th>`
              : `<th style="width: 35%; background-color: #1a2649; color: #ffffff; padding: 7px;">Product/Services</th>`
          }
         ${
           showDiscountColumn
             ? ` <th style="width: 15%; background-color: #1a2649; color: #ffffff; text-align: right; padding: 7px;">Price</th>`
             : ` <th style="width: 20%; background-color: #1a2649; color: #ffffff; text-align: right; padding: 7px;">Price</th>`
         }
         ${
           showDiscountColumn
             ? ` <th style="width: 15%; background-color: #1a2649; color: #ffffff; text-align: right; padding: 7px;">Quantity</th>`
             : ` <th style="width: 20%; background-color: #1a2649; color: #ffffff; text-align: right; padding: 7px;">Quantity</th>`
         }
          ${
            showDiscountColumn
              ? `<th style="width: 15%; background-color: #1a2649; color: #ffffff; text-align: right; padding: 7px;">Discount %</th>`
              : ``
          }
          <th style="width: 15%; background-color: #1a2649; color: #ffffff; text-align: right; padding: 7px;">Total</th>
        </tr>`;

      let tbody = document.createElement("tbody");

      chunk.forEach((item, index) => {
        let row = document.createElement("tr");
        row.style.padding = "2px";
        // row.style.borderBottom ='1px grey'

        const itemTotal = Number(item.Total);
        carryOverSum += itemTotal;

        row.innerHTML = `
          <td style="padding: 2px;">${currentIndex++}</td>
          <td style="text-align: left; padding: 2px;">${
            buttonPrintLable === false
              ? item.ItemVariationName || item.ItemName
              : item.ItemVariationPrintName ||
                item.ItemVariationName ||
                item.ItemName
          }</td>
          <td style="text-align: right; padding: 2px;"></td>
          <td style="text-align: right; padding: 2px;"></td>
          <td style="text-align: right; padding: 2px;"></td>
          <td style="text-align: right; padding: 2px;"></td>
        `;

        let detailsRow = document.createElement("tr");
        detailsRow.style.padding = "2px";
        detailsRow.style.borderBottom = "0.1px solid #dcdcdc";

        detailsRow.innerHTML = `
          <td style="padding: 2px;"></td>
          <td style="text-align: left; padding: 2px;"></td>
          <td style="text-align: right; padding: 2px;">$ ${Number(
            item.Price
          ).toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}</td>
          <td style="text-align: right; padding: 2px;">${Number(
            item.Quantity
          ).toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}</td>
        ${
           discountEntireSale
             ? ` <td style="text-align: right; padding: 2px; color: black;">${Number(
                 item.Discountpercent
               ).toLocaleString("en-US", {
                 minimumFractionDigits: 2,
                 maximumFractionDigits: 2,
               })}</td>`
             : ``
         }
          <td style="text-align: right; padding: 2px;">$ ${itemTotal.toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}</td>
        `;

        tbody.appendChild(row);
        tbody.appendChild(detailsRow);
      });

      table.appendChild(thead);
      table.appendChild(tbody);

      let tfoot = document.createElement("tfoot");
      tfoot.innerHTML = `
   ${
     showDiscountColumn
       ? `     <tr>
          <td colspan="5" style="text-align: right; padding: 2px;"><strong>Carry Over:</strong></td>
          <td style="text-align: right; padding: 2px;">$ ${carryOverSum.toLocaleString("en-US", {
             minimumFractionDigits: 2,
             maximumFractionDigits: 2,
           })}</td>
        </tr>`
       : `     <tr>
          <td colspan="4" style="text-align: right; padding: 2px;"><strong>Carry Over:</strong></td>
          <td style="text-align: right; padding: 2px;">$ ${carryOverSum.toLocaleString("en-US", {
             minimumFractionDigits: 2,
             maximumFractionDigits: 2,
           })}</td>
        </tr>`
   }
      `;

      // Add page number in a separate row
      let pageRow = document.createElement("tr");
      pageRow.innerHTML = `
        <td colspan="6" style="text-align: center; padding: 2px;">
          Page ${pageIndex + 1} of ${chunks.length}
        </td>
      `;

      tfoot.appendChild(pageRow);
      table.appendChild(tfoot);
      page.appendChild(table);

      // Append the page to the print container
      printContainer.appendChild(page);

      // Add a page break and the footer on a new page if the last chunk has more than 3 items
      if (pageIndex === chunks.length - 1) {
        page.appendChild(TotalfooterElement.cloneNode(true));
        if (chunk.length > 11) {
          // Add a new page for the footer if the last chunk has more than 7 items
          let footerPage = document.createElement("div");
          footerPage.appendChild(footerElement.cloneNode(true));
          if (pageIndex + 1 == chunks.length) {
            let tfoots = document.createElement("tfoot");
            tfoots.innerHTML = `
            <tr colspan="3" style="text-align: right; padding: 2px;> 
            <td colspan="3" style="text-align: right; padding: 2px; margin-top: -12px;">
                <td colspan="3" style="text-align: right; padding: 2px; margin-top: -12px;"> Page ${
                  pageIndex + 2
                } of ${chunks.length + 1} </td>   
              </td>
            </tr>
  
            `;

            footerPage.appendChild(tfoots);
          }

          printContainer.appendChild(footerPage);
        } else {
          // Append footer on the same page if the last chunk has 7 or fewer items
          page.appendChild(footerElement.cloneNode(true));
        }
      }
    });


    const isMobile = window.innerWidth <= 768;
    // setLoading(false);
    // Generate the PDF after a short delay
    setTimeout(() => {
      const opt = {
        margin: 0.2,
        filename: `#${headerData?.Posid} - ${
          headerData?.CompanyAddress || ""
        } Invoice.pdf`, //"ReceivingInvoice.pdf",
        html2canvas: { scale: 5 }, // Increase the scale for better resolution
        jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
      };
      html2pdf()
        .from(printContainer)
        .set(opt)
        .output("blob")
        .then((pdfBlob) => {
          const pdfUrl = URL.createObjectURL(pdfBlob); // Create a URL for the Blob
          window.open(pdfUrl, "_blank"); // Open the PDF in a new tab
        })
        .catch((err) => {
          console.error("Error generating PDF:", err);
        });
    }, 50);
  };

  //Function for download
  const handleCustomInvoiceDownload = (e) => {
     e.preventDefault();

     let headerElement = document.querySelector("#custominvoiceheader");
     // let header1Element = document.querySelector("#header1");
     let footerElement = document.getElementById("footer");
     let TotalfooterElement = document.getElementById("customTotalfooter3");
 
 
      // Styling the footer elements
      footerElement.style.padding = "0 20px";
      footerElement.style.marginTop = "25px";
 
     const discountEntireSale = Number(itemData?.Discount || "[]");
 
     console.log(discountEntireSale, "book123");
 
     const showDiscountColumn = discountEntireSale > 0;
     const salesItems = itemData || [];
     const itemsPerPage = 18;
     const firstPageItemsCount = 13;
     const specialFirstPageItemsCount = 8;
     const totalItems = itemData.length;
     let carryOverSum = 0;
     let currentIndex = 1;
 
 
     console.log(showDiscountColumn, "book55555");
 
     if (!headerElement) {
       console.error("Header element is missing.");
       return;
     }
 
    
     const chunkArray = (array, specialCase) => {
       const chunks = [];
       if (specialCase) {
         if (array.length > specialFirstPageItemsCount) {
           chunks.push(array.slice(0, specialFirstPageItemsCount));
           chunks.push(array.slice(specialFirstPageItemsCount));
         } else {
           chunks.push(array);
         }
       } else {
         if (array.length > 0) {
           chunks.push(array.slice(0, firstPageItemsCount));
         }
         for (let i = firstPageItemsCount; i < array.length; i += itemsPerPage) {
           chunks.push(array.slice(i, i + itemsPerPage));
         }
       }
       return chunks;
     };
 
     const chunks = chunkArray(itemData, totalItems >= 7 && totalItems <= 14);
 
 
     let printContainer = document.createElement("div");
 
     chunks.forEach((chunk, pageIndex) => {
       let page = document.createElement("div");
       page.style.padding = "0 20px";
       page.style.pageBreakAfter = "always";
 
       // Append either header or header1 depending on the page index
       if (pageIndex === 0) {
         page.appendChild(headerElement.cloneNode(true));
       } else {
       //  page.appendChild(header1Element.cloneNode(true));
       }
 
       // Create a new table for the chunk
       let table = document.createElement("table");
       table.className = "table mt-1";
       table.style.width = "100%";
       table.style.tableLayout = "fixed";
       table.style.marginBottom = "10px";
       table.style.fontSize = "5px";
       table.style.borderCollapse = "collapse";
 
       let thead = document.createElement("thead");
       thead.innerHTML = `
         <tr>
           <th style="width: 10%; background-color: #1a2649; color: #ffffff; padding: 7px;">#</th>
           ${
             showDiscountColumn
               ? `<th style="width: 30%; background-color: #1a2649; color: #ffffff; padding: 7px;">Product/Services</th>`
               : `<th style="width: 35%; background-color: #1a2649; color: #ffffff; padding: 7px;">Product/Services</th>`
           }
          ${
            showDiscountColumn
              ? ` <th style="width: 15%; background-color: #1a2649; color: #ffffff; text-align: right; padding: 7px;">Price</th>`
              : ` <th style="width: 20%; background-color: #1a2649; color: #ffffff; text-align: right; padding: 7px;">Price</th>`
          }
          ${
            showDiscountColumn
              ? ` <th style="width: 15%; background-color: #1a2649; color: #ffffff; text-align: right; padding: 7px;">Quantity</th>`
              : ` <th style="width: 20%; background-color: #1a2649; color: #ffffff; text-align: right; padding: 7px;">Quantity</th>`
          }
           ${
             showDiscountColumn
               ? `<th style="width: 15%; background-color: #1a2649; color: #ffffff; text-align: right; padding: 7px;">Discount %</th>`
               : ``
           }
           <th style="width: 15%; background-color: #1a2649; color: #ffffff; text-align: right; padding: 7px;">Total</th>
         </tr>`;
 
       let tbody = document.createElement("tbody");
 
       chunk.forEach((item, index) => {
         let row = document.createElement("tr");
         row.style.padding = "2px";
         // row.style.borderBottom ='1px grey'
 
         const itemTotal = Number(item.Total);
         carryOverSum += itemTotal;
 
         row.innerHTML = `
           <td style="padding: 2px;">${currentIndex++}</td>
           <td style="text-align: left; padding: 2px;">${
             buttonPrintLable === false
               ? item.ItemVariationName || item.ItemName
               : item.ItemVariationPrintName ||
                 item.ItemVariationName ||
                 item.ItemName
           }</td>
           <td style="text-align: right; padding: 2px;"></td>
           <td style="text-align: right; padding: 2px;"></td>
           <td style="text-align: right; padding: 2px;"></td>
           <td style="text-align: right; padding: 2px;"></td>
         `;
 
         let detailsRow = document.createElement("tr");
         detailsRow.style.padding = "2px";
         detailsRow.style.borderBottom = "0.1px solid #dcdcdc";
 
         detailsRow.innerHTML = `
           <td style="padding: 2px;"></td>
           <td style="text-align: left; padding: 2px;"></td>
           <td style="text-align: right; padding: 2px;">$ ${Number(
             item.Price
           ).toLocaleString("en-US", {
             minimumFractionDigits: 2,
             maximumFractionDigits: 2,
           })}</td>
           <td style="text-align: right; padding: 2px;">${Number(
             item.Quantity
           ).toLocaleString("en-US", {
             minimumFractionDigits: 2,
             maximumFractionDigits: 2,
           })}</td>
         ${
            discountEntireSale
              ? ` <td style="text-align: right; padding: 2px; color: black;">${Number(
                  item.Discountpercent
                ).toLocaleString("en-US", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}</td>`
              : ``
          }
           <td style="text-align: right; padding: 2px;">$ ${itemTotal.toLocaleString("en-US", {
             minimumFractionDigits: 2,
             maximumFractionDigits: 2,
           })}</td>
         `;
 
         tbody.appendChild(row);
         tbody.appendChild(detailsRow);
       });
 
       table.appendChild(thead);
       table.appendChild(tbody);
 
       let tfoot = document.createElement("tfoot");
       tfoot.innerHTML = `
    ${
      showDiscountColumn
        ? `     <tr>
           <td colspan="5" style="text-align: right; padding: 2px;"><strong>Carry Over:</strong></td>
           <td style="text-align: right; padding: 2px;">$ ${carryOverSum.toLocaleString("en-US", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}</td>
         </tr>`
        : `     <tr>
           <td colspan="4" style="text-align: right; padding: 2px;"><strong>Carry Over:</strong></td>
           <td style="text-align: right; padding: 2px;">$ ${carryOverSum.toLocaleString("en-US", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}</td>
         </tr>`
    }
       `;
 
       // Add page number in a separate row
       let pageRow = document.createElement("tr");
       pageRow.innerHTML = `
         <td colspan="6" style="text-align: center; padding: 2px;">
           Page ${pageIndex + 1} of ${chunks.length}
         </td>
       `;
 
       tfoot.appendChild(pageRow);
       table.appendChild(tfoot);
       page.appendChild(table);
 
       // Append the page to the print container
       printContainer.appendChild(page);
 
       // Add a page break and the footer on a new page if the last chunk has more than 3 items
       if (pageIndex === chunks.length - 1) {
         page.appendChild(TotalfooterElement.cloneNode(true));
         if (chunk.length > 11) {
           // Add a new page for the footer if the last chunk has more than 7 items
           let footerPage = document.createElement("div");
           footerPage.appendChild(footerElement.cloneNode(true));
           if (pageIndex + 1 == chunks.length) {
             let tfoots = document.createElement("tfoot");
             tfoots.innerHTML = `
             <tr colspan="3" style="text-align: right; padding: 2px;> 
             <td colspan="3" style="text-align: right; padding: 2px; margin-top: -12px;">
                 <td colspan="3" style="text-align: right; padding: 2px; margin-top: -12px;"> Page ${
                   pageIndex + 2
                 } of ${chunks.length + 1} </td>   
               </td>
             </tr>
   
             `;
 
             footerPage.appendChild(tfoots);
           }
 
           printContainer.appendChild(footerPage);
         } else {
           // Append footer on the same page if the last chunk has 7 or fewer items
           page.appendChild(footerElement.cloneNode(true));
         }
       }
     });
 
 
     const isMobile = window.innerWidth <= 768;
     // setLoading(false);
     // Generate the PDF after a short delay
     setTimeout(() => {
      const opt = {
        margin: 0.2,
        filename: `#${headerData?.InvoiceNo} - ${
          headerData?.CompanyAddress || ""
        } Invoice.pdf`, // "SaleInvoice.pdf",
        html2canvas: { scale: 4 }, // Increase the scale for better resolution
        jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
      };
      html2pdf()
        .from(printContainer)
        .set(opt)
        .save()
        .then((pdf) => {
          console.log("PDF data exported:", pdf);
        });
    }, 50);
   
  };
  //Function for lookup receipt

  function calculateAmounts(item) {
    const price = parseFloat(item.Price);
    const quantity = parseFloat(item.Quantity);
    const discount = parseFloat(item.Discount);
    const tax = parseFloat(item.Tax);

    const discountAmount = (price * quantity * discount) / 100;
    const taxAmount =
      ((price * quantity - (price * quantity * discount) / 100) * tax) / 100;
    const totalAmount = price * quantity; // - discountAmount + taxAmount;

    return {
      ...item,
      discountAmount: discountAmount.toFixed(2),
      taxAmount: taxAmount.toFixed(2),
      totalAmount: totalAmount.toFixed(2),
    };
  }

  useEffect(() => {
    generateBarcodes();
    console.log("barcodeRefs", barcodeRefs);

    console.log(paramObject?.type, "paramtype");
    console.log(paramObject?.id, "paramObject31052024");

    if (paramObject?.id !== undefined) {
      setLoading(true);

      if (paramObject?.type !== undefined) {
        console.log(paramObject.id, "keyData");

        if (paramObject?.id || paramObject?.type) {
          axios
            .get(
              `${config.ecommBackendBaseUrl}/general/customerinvoicedetails?id=${paramObject?.id}&type=${paramObject?.type}`,
              {
                headers: {
                  "Content-Type": "application/json;charset=UTF-8",
                  "Access-Control-Allow-Origin": "*",
                },
              }
            )
            .then((res) => {
              if (res.data.ResponseCode === "SUCCESS") {
                let Data = res.data.ResponseData?.headerdata[0];
                console.log(Data, "getinvoiceprofiledata");
                setHeaderData(res.data.ResponseData?.headerdata[0]);
                setHeaderDatas(res.data.ResponseData);

                const finalItemData = res.data.ResponseData?.itemdata?.map(
                  (item) => calculateAmounts(item)
                );
                console.log(finalItemData, "885");
                setItemData(finalItemData);
              } else if (res.data.ResponseCode === "ERROR") {
                console.log(res.data.ResponseMessage);
              }
              setLoading(false);
            })
            .catch((error) => {
              console.log(error);
              setLoading(false);
            });
        }
      } else if (location.pathname.split("/")[1] === "ecompendingincoice") {
        console.log(paramObject.id, "07052024 0");

        if (paramObject?.id) {
          axios
            .get(
              `${config.salesconfigBaseUrl}/sales/ecominvoice?saleid=${paramObject?.id}&type=pending`,
              {
                headers: {
                  "Content-Type": "application/json;charset=UTF-8",
                  "Access-Control-Allow-Origin": "*",
                  Authorization: token,
                },
              }
            )
            .then((res) => {
              console.log("res======>", res);
              console.log("responseDAta====372", res.data.ResponseData);
              if (res.data.ResponseCode === "SUCCESS") {
                setResponseData(res.data.ResponseData);
                setSalesDetails(res.data.ResponseData.SalesDetails);
                setSalesDeliveryDetails(
                  res.data.ResponseData.SalesDeliveryDetails
                );
                setSalesItem(res.data.ResponseData.SalesItems);
                console.log("11", res.data.ResponseData);
              }
              setLoading(false);
            })
            .catch((err) => {
              console.log(err);
              setLoading(false);
            });
        }
      }
    }
  }, [paramObject.id]);

  // Another useEffect block if needed
  useEffect(() => {
    if (paramObject.id > 0) {
      setLoading(true);
      if (location.pathname.split("/")[1] !== "ecompendingincoice") {
        // add condition for remove api call for pending
        axios
          .get(
            `${config.salesconfigBaseUrl}/sales/${
              ecomreceipt ? "ecominvoice" : "lookupreceipt"
            }?saleid=${paramObject?.id > 0 ? paramObject?.id : 0}&type=approve`,
            {
              headers: {
                "Content-Type": "application/json;charset=UTF-8",
                "Access-Control-Allow-Origin": "*",
                Authorization: token,
              },
            }
          )
          .then((res) => {
            console.log("res======>", res);
            console.log("responseDAta====372", res.data.ResponseData);
            if (res.data.ResponseCode === "SUCCESS") {
              setResponseData(res.data.ResponseData);
              setcreateddate(
                res.data.ResponseData?.SalesDetails[0]?.CreatedDate
              );
              setModifiedDate(
                res.data.ResponseData?.SalesDetails[0]?.ModifiedDate
              );
              setSalesDetails(res.data.ResponseData.SalesDetails);
              setSalesDeliveryDetails(
                res.data.ResponseData.SalesDeliveryDetails
              );
              setSalesItem(res.data.ResponseData.SalesItems);
              console.log("11", res.data.ResponseData);
            }
            setLoading(false);
          })
          .catch((err) => {
            console.log(err);
            setLoading(false);
          });
      }
    }
  }, [paramObject.id]);

  //Function for export excel
  const handleExcelExport = () => {
    // console.log(responseData);
    const costfilter = salesItem.map(({ Itemcostprice, ...rest }) => rest);

    const data =
      salesItem.length > 0 &&
      checkUserPermission(PERMISSION_SHOW_COST_PRICE) == false
        ? costfilter
        : [];
    console.log(costfilter, "sale444");
    // Create a new workbook
    const workbook = XLSX.utils.book_new();

    // Convert the data to a worksheet
    const worksheet = XLSX.utils.json_to_sheet(data);

    // Add the worksheet to the workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // Save the workbook as an Excel file
    XLSX.writeFile(workbook, `customers_details_.xlsx`);
  };

  let sum;
  if (responseData.SalesItems || responseData.SalesItems !== undefined) {
    sum = responseData.SalesItems.reduce((total, item) => {
      return total + Number(item.Total);
    }, 0);
    sum = sum.toFixed(2);
  }
  console.log(sum);

  const handleUnSuspend = (pID) => {
    console.log("pID", pID);
  };

  const totalPages = Number(
    itemData?.length > 0
      ? Math.ceil(itemData?.length / ITEMS_PER_PAGE)
      : Math.ceil(responseData.SalesItems?.length / ITEMS_PER_PAGE)
  );
  // console.log(totalPages,"totalPages")

  // Invoice Date-
  let invoiceDate;
  if (responseData.SalesDetails) {
    invoiceDate = new Date(responseData.SalesDetails[0]?.Saletime);
    invoiceDate = invoiceDate.toLocaleDateString();
  }
  console.log(invoiceDate);

  // Delivery Date-
  let deliveryDate;
  if (responseData.SalesDeliveryDetails) {
    if (responseData.SalesDeliveryDetails[0]?.Estimateddeliveryorpickupdate) {
      deliveryDate = new Date(
        responseData.SalesDeliveryDetails[0]?.Estimateddeliveryorpickupdate
      );
      deliveryDate = deliveryDate.toLocaleDateString();
    } else {
      deliveryDate = "";
    }
  }
  console.log(deliveryDate);
  const handleToggle = () => {
    setbuttonPrintLable(!buttonPrintLable);
  };

  const OnfliteData = (row) => {
    setLoading(true);
    axios
      .post(
        `${config.salesconfigBaseUrl}/sales/saleonfleetID`,
        {
          id: salesItem[0]?.SaleId,
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        setLoading(false);
        // console.log(res.data.ResponseCode  , "123000")
        if (res.data.ResponseCode === "ERROR") {
          toastError(res.data.ResponseData);
        } else {
          toastSuccess("data Sync in  Onfleet Sucessfully ");
        }
      })
      .catch((error) => {
        setLoading(false);
      });

    // window.location.reload();
  };

  return (
    <>
      <Loader loading={loading} />
      {!ecomreceipt && <Sidebar />}
      <div className={ecomreceipt ? "m-5" : "page-wrapper"}>
        <div className="content">
          {!ecomreceipt ? (
            <>
              <div
                className="page-header"
                style={{
                  position: "fixed",
                  top: "2px",
                  zIndex: "999",
                }}
              >
                <div className="row breadcrumb-position">
                  <ul className="breadcrumb">
                    <li
                      className="breadcrumb-item"
                      style={{ marginLeft: "12px" }}
                    >
                      <Link to="/dashboard">Dashboard</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/sales">Sale List</Link>
                    </li>
                    <li className="breadcrumb-item active">Sale Receipt</li>
                  </ul>
                </div>
              </div>

              {salesdetails[0]?.IsVoid !== 1 && (
                <>
                  <Link
                    className="btn btn-sm btn-secondary me-1 mb-5"
                    to={`/manage-sales/${salesItem[0]?.SaleId}`}
                    // onClick={handleUnSuspend()}
                  >
                    Edit
                  </Link>

                  <Link
                    className="btn btn-sm btn-secondary me-1 mb-5"
                    to={`/sales-barcode-label/${salesItem[0]?.SaleId}`}
                  >
                    Barcode Labels
                  </Link>
                  <Link
                    className="btn btn-sm btn-secondary me-1 mb-5"
                    onClick={downloadPdf}
                  >
                    Barcode Sheet
                  </Link>
                  <Link
                    className="btn btn-sm btn-secondary me-1 mb-5"
                    onClick={handleExcelExport}
                  >
                    Excel Export
                  </Link>
                </>
              )}
              <Link
                className="btn btn-sm btn-secondary me-1 mb-5"
                to={`/manage-sales`}
                // to={`/manage-sales/${salesItem[0]?.SaleId}`}

                onClick={() =>
                  localStorage.setItem("Clone", salesItem[0]?.SaleId)
                }
                // onClick={handleUnSuspend(salesItem[0]?.SaleId)}
              >
                Clone
              </Link>
              <Link
                className="btn btn-sm btn-secondary me-1 mb-5"
                onClick={handlePrint}
              >
                Print
              </Link>
              {salesdetails[0]?.IsVoid !== 1 && (
                <>
                  <Link
                    className="btn btn-sm btn-secondary me-1 mb-5"
                    onClick={handlefullfilmentprintPrint}
                  >
                    Full Fillment
                  </Link>
                </>
              )}
              <Link
                className="btn btn-sm btn-secondary me-1 mb-5"
                onClick={handleDownload}
              >
                Download
              </Link>
              <Link
                className="btn btn-sm btn-secondary me-1 mb-5"
                onClick={handleToggle}
              >
                {buttonPrintLable ? "Original Name" : "Replace Name"}
              </Link>
              {salesdetails[0]?.DeliveryCount > 0 && (
                <Link
                  className="btn btn-sm btn-secondary me-1 mb-5 onfleet-color"
                  onClick={OnfliteData}
                >
                  OnFleet
                </Link>
              )}
              <Link className="btn btn-sm btn-secondary me-1 mb-5">
                <span className="Sync_Status_label_class">
                  {" "}
                  {responseData.SyncDetail &&
                  responseData.SyncDetail[0].SyncStatus === 0 ? (
                    <i class="fa fa-circle red_circle_for_sync"></i>
                  ) : (
                    <i class="fa fa-circle green_circle_for_sync"></i>
                  )}{" "}
                  {responseData.SyncDetail &&
                  responseData.SyncDetail[0].SyncStatus === 0
                    ? "Sync Fail"
                    : "Sync Success"}
                </span>
              </Link>
            </>
          ) : (
            <div className="row col-md-12">
              <div className="col-md-6">
                <Link
                  className="btn btn-sm btn-secondary me-1 mb-5"
                  onClick={
                    paramObject?.type === undefined
                      ? handlePrint
                      : handleCustomInvoicePrint
                  }
                >
                  Print
                </Link>
                <Link
                  className="btn btn-sm btn-secondary me-1 mb-5"
                  onClick={
                    paramObject?.type === undefined
                      ? handleDownload
                      : handleCustomInvoiceDownload
                  }
                >
                  Download
                </Link>
              </div>
              <div className="col-md-6 ecomheader">Ecomm Receipt</div>
            </div>
          )}

          {paramObject?.type === undefined ? (
            <>
              <div id="print" className="receipt-card-body">
                {/* Sales Receipt */}
                <div className="card-body">
                  {/* Header */}
                  <div id="header">
                    <div
                      style={{
                        color: "#000 !important",
                        textAlign: "left !important",
                      }}
                    >
                      <div className="row">
                        <div
                          className="col-md-5"
                          style={{ marginLeft: "20px", color: "black" }}
                        >
                          <p
                            className="fw-bold"
                            style={{
                              fontFamily: "Inter, sans-serif",
                              fontSize: "20px",
                              color: "black",
                            }}
                          >
                            {responseData?.CompanyDetails &&
                              responseData?.CompanyDetails[0]?.CompanyName}
                          </p>{" "}
                          {/* <br /> */}
                          <p
                            style={{
                              textAlign: "left",
                              fontFamily: "Inter, sans-serif",
                              fontSize: "20px",
                              color: "black",
                            }}
                          >
                            {responseData?.CompanyDetails &&
                              responseData?.CompanyDetails[0]?.CompanyAddress}
                          </p>
                          {/* <br /> */}
                          <p
                            style={{
                              textAlign: "right",
                              fontFamily: "Inter, sans-serif",
                              color: "black",
                            }}
                          >
                            {responseData?.CompanyDetails &&
                              responseData?.CompanyDetails[0]?.Website}
                          </p>{" "}
                        </div>
                        <div className="col-md-2"></div>
                        <div
                          className="col-md-4"
                          style={{
                            textAlign: "start",
                            color: "black",
                            paddingLeft: "50px",
                          }}
                        >
                          <div
                            className="fw-bold"
                            style={{
                              fontFamily: "Inter, sans-serif",
                              fontSize: "14px",
                              color: "black",
                            }}
                          >
                            {/* {salesdetails[0]?.SalesType == "Sale"
                            ? "Invoice"
                            : salesdetails[0]?.SalesType} */}
                          </div>

                          <div
                            className="fw-bold"
                            style={{
                              fontFamily: "Inter, sans-serif",
                              fontSize: "18px",
                              color: "black",
                            }}
                          >
                            Invoice No - {salesdetails[0]?.Posid}
                          </div>

                          {/* <div
                          className="fw-bold"
                          style={{
                            fontFamily: "Inter, sans-serif",
                            marginTop: "2px",
                            fontSize: "10px",color:"black"
                          }}
                        >
                          Balance Due
                        </div>

                        <div
                          className="fw-bold"
                          style={{
                            fontFamily: "Inter, sans-serif",
                            fontSize: "12px",color:"black"
                          }}
                        >
                          $
                          {Number(salesdetails[0]?.Total).toLocaleString(
                            "en-US",
                            {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            }
                          )}
                        </div> */}
                        </div>
                      </div>

                      <hr></hr>
                      <div
                        className="row"
                        style={{
                          marginTop: "0px",
                          marginTop: "-8px",
                          color: "black",
                        }}
                      >
                        <div className="col-md-4">
                          {/* <p style={{ fontFamily: "Inter, sans-serif" , color:"black" }}>
                          Bill To
                        </p> */}

                          {responseData?.CustomerDetails?.map((item, index) => {
                            return (
                              <>
                                <p
                                  className="fw-bold mt-1"
                                  style={{
                                    fontFamily: "Inter, sans-serif",
                                    color: "black",
                                  }}
                                >
                                  Bill To :
                                  {/* {item?.Name}({item?.personid}) */}
                                </p>
                                {/* <br /> */}
                                <p
                                  style={{
                                    fontFamily: "Inter, sans-serif",
                                    color: "black",
                                  }}
                                >
                                  Company Name:{" "}
                                  <b style={{ color: "black" }}>
                                    {item?.personid} - {item?.Companyname}
                                  </b>
                                </p>
                                {/* <br /> */}
                                <p
                                  style={{
                                    fontFamily: "Inter, sans-serif",
                                    color: "black",
                                  }}
                                >
                                  Address  : 
                                   {/* {item?.Companyname},{item?.Address} , {item.Address && (item.Zip == "" || item.Zip == null) ? "" : ` ${item?.city} , ${item?.Zip}  ${item.StateProvince}  `} , {item.Country} */}
                                   {/* {item?.Companyname && `${item.Companyname}, `} */}
{/* {item?.Address && `${item.Address}, `}
{item?.Address2 && `${item.Address2}, `}
{item?.city && `${item.city}, `}
{item?.StateProvince && `${item.StateProvince} `}
{(item?.Zip && item.Zip !== "" && item.Zip !== null) && `${item.Zip} `},
{item?.Country && `${item.Country}`} */}
{item?.Address && `${item.Address}, `}
{item?.Address2 && `${item.Address2}, `}
{item?.city && `${item.city}, `}
{item?.StateProvince && `${item.StateProvince} `}
{(item?.Zip && item.Zip !== "" && item.Zip !== null) && `${item.Zip}, `}
{item?.Country && `${item.Country}`}


                                </p>

                                {/* <br /> */}
                                {/* <p
                                style={{
                                  fontFamily: "Inter, sans-serif",
                                  color: "black",
                                }}
                              >
                                city: ({item?.city})
                              </p> */}
                                {/* <br /> */}
                                {/* <p
                                style={{
                                  fontFamily: "Inter, sans-serif",
                                  color: "black",
                                }}
                              >
                                Zipcode: {item?.Zip}
                              </p> */}
                                <p
                                  style={{
                                    fontFamily: "Inter, sans-serif",
                                    color: "black",
                                  }}
                                >
                                  Phone No :{" "}
                                  {item?.PhoneNumber
                                    ? item.PhoneNumber.replace(
                                        /(\d{3})(\d{3})(\d{4})/,
                                        "($1) $2-$3"
                                      )
                                    : ""}
                                  {/* Phone No : {item?.PhoneNumber}({item?.Email}) */}
                                </p>
                                <p
                                  style={{
                                    fontFamily: "Inter, sans-serif",
                                    color: "black",
                                  }}
                                >
                                  Email: {item.Email}
                                </p>
                                <p
                                  style={{
                                    fontFamily: "Inter, sans-serif",
                                    color: "black",
                                  }}
                                >
                                  REP : {item?.REP}
                                </p>
                                <p
                                  style={{
                                    fontFamily: "Inter, sans-serif",
                                    color: "black",
                                  }}
                                >
                                  Route : {item?.Route}
                                </p>
                                {/* <br /> */}
                                <p
                                  style={{
                                    fontFamily: "Inter, sans-serif",
                                    color: "black",
                                  }}
                                >
                                  LEVEL : {item?.LEVEL}
                                </p>
                              </>
                            );
                          })}
                        </div>

                        <div className="col-md-4">
                          {/* <p style={{ fontFamily: "Inter, sans-serif" , color:"black" }}>
                          Bill To
                        </p> */}

                          {responseData?.CustomerDetails?.map((item, index) => {
                            return (
                              <>
                                {/* <p
                                className="mt-1"
                                style={{
                                  fontFamily: "Inter, sans-serif",
                                  color: "black",
                                }}
                              >
                                Email : {item?.Email}
                              </p> */}
                                {/* <br /> */}

                                {/* <br /> */}

                                {/* <p
                                style={{
                                  fontFamily: "Inter, sans-serif",
                                  color: "black",
                                }}
                              >
                                Shipping To:{" "}
                                {salesdetails[0]?.shippingaddress == "" || null 
                                  ?  ('Company Name':{" "}
                                  <b style={{ color: "black" }}>
                                    {item?.personid} - {item?.Companyname}
                                  </b>)
                                  : " Same as Billing Address"}
                              </p> */}
                                <p
                                  className="text-bold mt-1"
                                  style={{
                                    fontFamily: "Inter, sans-serif",
                                    color: "black",
                                  }}
                                >
                                  <span
                                    style={{
                                      fontWeight: "bold",
                                      color: "black",
                                    }}
                                  >
                                    Ship To:
                                  </span>{" "}
                                  <br />
                                  Company Name :{" "}
                                  {salesdetails[0]?.shippingaddress == "" ||
                                  salesdetails[0]?.shippingaddress == null
                                    ? item?.Companyname
                                    : salesdetails[0]?.shippingaddress}
                                </p>

                                {/* <br /> */}
                                {/* <p style={{ fontFamily: "Inter, sans-serif", color:'black'}}>
                                Zipcode: {item?.Zip}
                              </p> */}
                                {/* <p style={{ fontFamily: "Inter, sans-serif", color:'black'}}>
                                Phone No : {item?.PhoneNumber? item.PhoneNumber.replace(/(\d{3})(\d{3})(\d{4})/,"($1) $2-$3"): "N/A"}({item?.Email})
                                Phone No : {item?.PhoneNumber}({item?.Email})
                              </p> */}
                              </>
                            );
                          })}

                          {/* <p style={{ fontFamily: "Inter, sans-serif",color:'black' }}>
                          shipping address:{" "}
                          {salesdetails[0]?.shippingaddress
                            ? salesdetails[0]?.shippingaddress
                            : " Same as Billing Address"}
                        </p> */}
                        </div>

                        <div className="col-md-4">
                          <div className="row">
                            <p
                              style={{
                                alignItems: "start",
                                fontFamily: "Inter, sans-serif",
                                display: "flex",
                                color: "black",
                              }}
                              className="col-md-12"
                            >
                              Invoice Date: {salesdetails[0]?.Saletime}
                            </p>
                          </div>

                          <div className="row">
                            <p
                              className="col-md-12"
                              style={{
                                fontFamily: "Inter, sans-serif",
                                color: "black",
                              }}
                            >
                              Type:{" "}
                              {salesdetails[0]?.SalesType == "Sale"
                                ? "Invoice"
                                : salesdetails[0]?.SalesType}
                            </p>
                          </div>
                          {/* <hr /> */}
                          <div className="row">
                            <p
                              style={{
                                alignItems: "start",
                                display: "flex",
                                fontFamily: "Inter, sans-serif",
                                color: "black",
                              }}
                              className="col-md-12"
                            >
                              Terms:{" "}
                              {responseData?.SalesDetails &&
                              " " + responseData?.SalesDetails[0]?.termsname
                                ? responseData?.SalesDetails[0]?.termsname
                                : "NA"}
                            </p>
                          </div>
                          {/* <hr /> */}
                          <div className="row">
                            <p
                              style={{
                                alignItems: "start",
                                fontFamily: "Inter, sans-serif",
                                display: "flex",
                                color: "black",
                              }}
                              className="col-md-12"
                            >
                              Due Date: {salesdetails[0]?.DueDate}
                            </p>
                          </div>

                          <div className="row">
                            <p
                              style={{
                                alignItems: "start",
                                display: "flex",
                                fontFamily: "Inter, sans-serif",
                                color: "black",
                              }}
                              className="col-md-12"
                            >
                              Created Date:{" "}
                              {moment(createddata).format("MM/DD/YYYY h:mm A")}
                            </p>
                          </div>

                          <div className="row">
                            <p
                              className="col-md-12"
                              style={{
                                fontFamily: "Inter, sans-serif",
                                color: "black",
                              }}
                            >
                              Created BY : {salesdetails[0]?.CreatedName}
                            </p>
                          </div>

                          <div className="row">
                            <p
                              style={{
                                alignItems: "start",
                                display: "flex",
                                fontFamily: "Inter, sans-serif",
                                color: "black",
                              }}
                              className="col-md-12"
                            >
                              Modified Date:{" "}
                              {ModifiedDate
                                ? moment(ModifiedDate).format(
                                    "MM/DD/YYYY h:mm A"
                                  )
                                : ""}
                            </p>
                          </div>

                          <div className="row">
                            <p
                              className="col-md-12"
                              style={{
                                fontFamily: "Inter, sans-serif",
                                color: "black",
                              }}
                            >
                              Modified BY : {salesdetails[0]?.ModifideName}
                              {/* Modified BY :{" "}
                            {salesdetails[0]?.ModifideName} */}
                            </p>
                          </div>
                          <p
                            id="page-no"
                            style={{
                              fontFamily: "Inter, sans-serif",
                              display: "none",
                            }}
                          >
                            {/* {currentPage} */}
                            Page No : {currentPage}/{totalPages}
                          </p>
                        </div>
                      </div>
                    </div>
                    <hr />
                  </div>

                  <div style={{ display: "none" }}>
                    <div id="header1">
                      <div
                        style={{
                          color: "#000 !important",
                          textAlign: "left !important",
                        }}
                      >
                        <div className="row">
                          <div
                            className="col-md-6"
                            style={{ marginLeft: "20px" }}
                          >
                            <p
                              className="fw-bold"
                              style={{
                                fontFamily: "Inter, sans-serif",
                                fontSize: "20px",
                              }}
                            >
                              {responseData?.CompanyDetails &&
                                responseData?.CompanyDetails[0]?.CompanyName}
                            </p>
                            <p
                              style={{
                                textAlign: "left",
                                fontFamily: "Inter, sans-serif",
                                fontSize: "20px",
                              }}
                            >
                              {responseData?.CompanyDetails &&
                                responseData?.CompanyDetails[0]?.CompanyAddress}
                            </p>
                            <p
                              style={{
                                textAlign: "right",
                                fontFamily: "Inter, sans-serif",
                              }}
                            >
                              {responseData?.CompanyDetails &&
                                responseData?.CompanyDetails[0]?.Website}
                            </p>
                          </div>
                          <div className="col-md-1"></div>
                          <div
                            className="col-md-4"
                            style={{ textAlign: "start" }}
                          >
                            <div
                              className="fw-bold"
                              style={{
                                fontFamily: "Inter, sans-serif",
                                fontSize: "14px",
                              }}
                            >
                              {salesdetails[0]?.SalesType === "Sale"
                                ? "Invoice"
                                : salesdetails[0]?.SalesType}
                            </div>

                            <div
                              className="fw-bold"
                              style={{
                                fontFamily: "Inter, sans-serif",
                                fontSize: "18px",
                              }}
                            >
                              Invoice No - {salesdetails[0]?.Posid}
                            </div>

                            {/* <div
                            className="fw-bold"
                            style={{
                              fontFamily: "Inter, sans-serif",
                              marginTop: "2px",
                              fontSize: "10px",
                            }}
                          >
                            Balance Due
                          </div>

                          <div
                            className="fw-bold"
                            style={{
                              fontFamily: "Inter, sans-serif",
                              fontSize: "10px",
                            }}
                          >
                            $
                            {Number(salesdetails[0]?.Total).toLocaleString(
                              "en-US",
                              {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              }
                            )}
                          </div> */}
                          </div>
                        </div>

                        {/* <hr></hr> */}
                        <div
                          className="row"
                          style={{ marginTop: "0px", marginTop: "-8px" }}
                        >
                          <div className="col-md-4">
                            {/* Optional content */}
                          </div>
                        </div>
                      </div>
                      <hr />
                    </div>
                  </div>

                  {/* Body */}
                  <div className="table-responsive" id="body">
                    <table className="table mt-1">
                      <thead>
                        <tr>
                          <th className="col-md">#</th>
                          <th className="col-md-3">Product/Services</th>

                          <th
                            className="col-md-2"
                            style={{ textAlign: "right" }}
                          >
                            Price
                          </th>
                          <th
                            className="col-md-2"
                            style={{ textAlign: "right" }}
                          >
                            Quantity
                          </th>
                          <th
                            className="col-md-2"
                            style={{ textAlign: "right" }}
                          >
                            Discount %
                          </th>
                          {/* <th className="col-md-2" style={{ textAlign: "right" }}>
                          Tax %
                        </th> */}
                          <th
                            className="col-md-2"
                            style={{ textAlign: "right" }}
                          >
                            Total
                          </th>
                        </tr>
                      </thead>

                      <tbody>
                        {responseData?.SalesItems?.map((item, index) => {
                          return (
                            <>
                              <tr key={index}>
                                <td
                                  style={{ color: "black" }}
                                  className="col-md"
                                >
                                  {++index}
                                </td>

                                <td
                                  style={{ textAlign: "left", color: "black" }}
                                  className="col-md-2"
                                >
                                  <div
                                    style={{ color: "black" }}
                                    className="col-md-2"
                                  >
                                    {buttonPrintLable ? (
                                      <p
                                        className="fw-bold"
                                        style={{
                                          fontFamily: "Inter, sans-serif",
                                        }}
                                      >
                                        {item?.ItemPrintName ||
                                        item?.ItemVariationPrintName
                                          ? item?.ItemVariationPrintName
                                            ? item?.ItemVariationPrintName
                                            : item?.ItemPrintName
                                          : item?.ItemVariationName
                                          ? item?.ItemVariationName
                                          : item?.ItemName}
                                      </p>
                                    ) : (
                                      <p
                                        className="fw-bold"
                                        style={{
                                          fontFamily: "Inter, sans-serif",
                                          color: "black",
                                        }}
                                      >
                                        {item?.ItemVariationName
                                          ? item?.ItemVariationName
                                          : item?.ItemName}
                                      </p>
                                    )}
                                  </div>

                                  {!buttonPrintLable ? (
                                    <p style={{ color: "black" }}>
                                      Item Number:
                                      {item.Itemnumber}
                                    </p>
                                  ) : (
                                    <></>
                                  )}
                                </td>
                                {/* 
                              <td
                                className="col-md-2"
                                style={{ textAlign: "right" }}
                              >
                                ${Number(item.Serialnumber).toFixed(2)}
                              </td> */}

                                <td
                                  className="col-md-2"
                                  style={{ textAlign: "right", color: "black" }}
                                >
                                  ${Number(item.Itemunitprice).toFixed(2)}
                                </td>

                                <td
                                  className="col-md-2"
                                  style={{ textAlign: "right", color: "black" }}
                                >
                                  {Number(item.Quantitypurchased).toFixed(2)}
                                </td>

                                <td
                                  className="col-md-2"
                                  style={{ textAlign: "right", color: "black" }}
                                >
                                  {Number(item.Discountpercent).toFixed(2)}
                                </td>

                                <td
                                  className="col-md-2"
                                  style={{ textAlign: "right", color: "black" }}
                                >
                                  {Number(item.Total).toFixed(2)}
                                </td>
                              </tr>
                            </>
                          );
                        })}
                      </tbody>
                    </table>

                    <div
                      style={{ textAlign: "right", color: "black" }}
                      className="mt-3"
                    >
                      <p style={{ margin: "0" }}>
                        <strong>Sub Total: </strong>$
                        <span style={{ color: "black" }}>
                          {Number(salesdetails[0]?.Subtotal).toLocaleString(
                            "en-US",
                            {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            }
                          )}
                        </span>
                      </p>
                      <p style={{ margin: "0", color: "black" }}>
                        <strong>Tax : </strong>$
                        <span style={{ color: "black" }}>
                          {Number(salesdetails[0]?.Tax).toLocaleString(
                            "en-US",
                            {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            }
                          )}
                        </span>
                      </p>
                      <p style={{ margin: "0", color: "black" }}>
                        <strong>Discount: </strong>$
                        <span style={{ color: "black" }}>
                          {Number(
                            salesdetails[0]?.Discountentiresale
                          ).toLocaleString("en-US", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                        </span>
                      </p>
                      <p style={{ margin: "0", color: "black" }}>
                        <strong>DeliveryFees : </strong>$
                        <span style={{ color: "black" }}>
                          {Number(
                            SalesDeliveryDetails[0]?.DeliveryFees || 0
                          ).toLocaleString("en-US", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                        </span>
                      </p>
                      <p style={{ margin: "0", color: "black" }}>
                        <strong>Total Amount: </strong>$
                        <span style={{ color: "black" }}>
                          {Number(salesdetails[0]?.Total).toLocaleString(
                            "en-US",
                            {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            }
                          )}
                        </span>
                      </p>
                    </div>
                    <hr />
                  </div>

                  {/* Footer */}
                  <div style={{ display: "none" }}>
                    <div id="Totalfooter">
                      <div className="row">
                        <div className="col-md-6">
                          <p style={{ margin: "0", color: "black" }}>
                            <strong>Comment: </strong>
                            {salesdetails[0]?.Comment}
                          </p>
                        </div>

                        <div
                          style={{ textAlign: "right", color: "black" }}
                          className="mt-3 col-md-6"
                        >
                          <p style={{ margin: "0" }}>
                            <strong>Sub Total: </strong>${" "}
                            {Number(salesdetails[0]?.Subtotal).toLocaleString(
                              "en-US",
                              {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              }
                            )}
                          </p>
                          <p style={{ margin: "0" }}>
                            <strong>Total item : </strong>
                            {Number(salesItem.length).toLocaleString("en-US", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </p>
                          <p style={{ margin: "0" }}>
                            <strong>Total Qty : </strong>
                            {Number(sumss).toLocaleString("en-US", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </p>
                          <p style={{ margin: "0" }}>
                            <strong>Total Amount: </strong>$
                            {Number(salesdetails[0]?.Total).toLocaleString(
                              "en-US",
                              {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              }
                            )}
                          </p>
                        </div>
                      </div>
                    </div>

                    <div id="customTotalfooter">
                      <div className="row">
                        <div className="col-md-6">
                          <p style={{ margin: "0" }}>
                            <strong>Comment: </strong>
                            {salesdetails[0]?.Comment}
                          </p>
                        </div>

                        <div
                          style={{ textAlign: "right", color: "black" }}
                          className="mt-3 col-md-6"
                        >
                          <p style={{ margin: "0" }}>
                            <strong>Sub Total: </strong>${" "}
                            {Number(headerData?.Subtotal).toLocaleString(
                              "en-US",
                              {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              }
                            )}
                          </p>
                          <p style={{ margin: "0" }}>
                            <strong>Total item : </strong>
                            {Number(itemData.length).toLocaleString("en-US", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </p>
                          <p style={{ margin: "0" }}>
                            <strong>Total Qty : </strong>
                            {Number(sumss1).toLocaleString("en-US", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </p>
                          <p style={{ margin: "0" }}>
                            <strong>Total Amount: </strong>$
                            {Number(headerData?.Total).toLocaleString("en-US", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="row" id="footer">
                      <div className="row">
                        <p
                          style={{
                            marginTop: "20px",
                            textAlign: "center",
                            fontSize: "10px",
                            color: "black",
                          }}
                        >
                          BY SIGNING AND ACCEPTING THE ORDER CUSTOMER AGREES
                          THAT THE INFORMATION ABOVE IS TRUE & THEREFORE IS
                          RESPONSIBLE FOR THE ENTIRE BALANCE ON THE INVOICE. ALL
                          CREDIT MUST BE APPROVED BY THE OFFICE. NO RETURNS
                          ACCEPTED. NO RETURN/EXCHANGE ON ANY ELECTRONIC
                          CIGARETTES OR VAPE ITEMS NO EXCEPTIONS. OVER 5000+
                          CONVENIENCE STORE ITEMS GENERAL MERCHANDISE. QUICK
                          DELIVERY..LOW PRICES. THERE IS $35 BANK FEE FOR ALL
                          RETURNED CHECKS. CUSTOMER IS RESPONSIBLE FOR ALL STATE
                          AND LOCAL TAXES. SALE OF FLAVORED VAPES NOT ALLOWED IN
                          CERTAIN STATES, CUSTOMER IS RESPONSIBLE FOR ALL STATE
                          AND LOCAL COMPLIANCE RULES AND REGULATIONS.{" "}
                        </p>

                        <div
                          className="d-flex"
                          style={{
                            position: "relative",
                            justifyContent: "space-between",
                            padding: "20px",
                            color: "black",
                          }}
                        >
                          <div style={{ gap: "50px" }}>
                            <p style={{ marginTop: "30px", color: "black" }}>
                              {" "}
                              Customer Signature: ____________________________{" "}
                            </p>
                            <p style={{ marginTop: "25px", color: "black" }}>
                              {" "}
                              Date: ___________________________{" "}
                            </p>
                          </div>

                          {/* Second div aligned to the right and placed inside a box */}
                          <div
                            style={{
                              border: "1px solid black",
                              padding: "10px",
                              width: "300px",
                              position: "absolute",
                              right: "0",
                              top: "40px",
                              color: "black",
                            }}
                          >
                            <p style={{ marginTop: "10px", color: "black" }}>
                              {" "}
                              PREPARED BY: _________________________{" "}
                            </p>
                            <p style={{ marginTop: "20px", color: "black" }}>
                              {" "}
                              CHECKED BY: __________________________{" "}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div>
                {responseData.SyncDetail &&
                responseData.SyncDetail[0].SyncStatus == 0 ? (
                  <Link
                    className="btn btn-sm btn-secondary me-1 mt-5"
                    // onClick={OnfliteData}
                  >
                    {`${
                      responseData.SyncDetail &&
                      responseData.SyncDetail[0].Message
                    }`}
                  </Link>
                ) : (
                  ""
                )}
              </div>
            </>
          ) : (
            <>
              <div id="print" className="receipt-card-body">
                <div className="card-body">
                  {/* Header */}
                  <div id="custominvoiceheader">
                    <div style={{ color: "#000 !important" }}>
                      <div>
                        <div className="row">
                          <div
                            className="col-md-5"
                            style={{ marginLeft: "20px", color: "black" }}
                          >
                            <p
                              className="fw-bold"
                              style={{
                                fontFamily: "Inter, sans-serif",
                                fontSize: "20px",
                                color: "black",
                              }}
                            >
                              {headerData && headerData?.CompanyName}
                            </p>{" "}
                            {/* <br /> */}
                            <p
                              style={{
                                textAlign: "left",
                                fontFamily: "Inter, sans-serif",
                                fontSize: "20px",
                                color: "black",
                              }}
                            >
                              {headerData?.CompanyAddress &&
                                headerData?.CompanyAddress}
                            </p>
                            {/* <br /> */}
                            <p
                              style={{
                                textAlign: "right",
                                fontFamily: "Inter, sans-serif",
                                color: "black",
                              }}
                            >
                              {headerData?.Website && headerData?.Website}
                            </p>{" "}
                          </div>

                          <div className="col-md-2"></div>

                          <div
                            className="col-md-4"
                            style={{
                              textAlign: "start",
                              color: "black",
                              paddingLeft: "50px",
                            }}
                          >
                            <div
                              className="fw-bold"
                              style={{
                                fontFamily: "Inter, sans-serif",
                                fontSize: "14px",
                                color: "black",
                              }}
                            >
                              {/* {salesdetails[0]?.SalesType == "Sale"
                            ? "Invoice"
                            : salesdetails[0]?.SalesType} */}
                            </div>

                            <div
                              className="fw-bold"
                              style={{
                                fontFamily: "Inter, sans-serif",
                                fontSize: "18px",
                                color: "black",
                              }}
                            >
                              Invoice No -{headerData?.InvoiceNo}
                            </div>

                            {/* <div
                          className="fw-bold"
                          style={{
                            fontFamily: "Inter, sans-serif",
                            marginTop: "2px",
                            fontSize: "10px",color:"black"
                          }}
                        >
                          Balance Due
                        </div>

                        <div
                          className="fw-bold"
                          style={{
                            fontFamily: "Inter, sans-serif",
                            fontSize: "12px",color:"black"
                          }}
                        >
                          $
                          {Number(salesdetails[0]?.Total).toLocaleString(
                            "en-US",
                            {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            }
                          )}
                        </div> */}
                          </div>
                        </div>
                        <hr></hr>

                        <div
                          className="row"
                          style={{
                            marginTop: "0px",
                            marginTop: "-8px",
                            color: "black",
                          }}
                        >
                          <div className="col-md-4">
                         

                           
                                  <>
                                    <p
                                      className="fw-bold mt-1"
                                      style={{
                                        fontFamily: "Inter, sans-serif",
                                        color: "black",
                                      }}
                                    >
                                      Bill To :
                                      {/* {item?.Name}({item?.personid}) */}
                                    </p>
                                    {/* <br /> */}
                                    <p
                                      style={{
                                        fontFamily: "Inter, sans-serif",
                                        color: "black",
                                      }}
                                    >
                                      Company Name:{" "}
                                      <b style={{ color: "black" }}>
                                      {headerData?.CompanyAddress}
                                      </b>
                                    </p>
                                    {/* <br /> */}
                                    <p
                                      style={{
                                        fontFamily: "Inter, sans-serif",
                                        color: "black",
                                      }}
                                    >
                                      Address: {headerData?.DeliveryAddress} ,
                    
                                    </p>

                                    <p
                                style={{
                                  fontFamily: "Inter, sans-serif",
                                  color: "black",
                                }}
                              >
                                Country: {headerData?.CustomerCountry}
                              </p> 
                                  
                                     <p
                                style={{
                                  fontFamily: "Inter, sans-serif",
                                  color: "black",
                                }}
                              >
                                Zipcode:  {headerData?.CustomerZip}
                              </p>
                                    <p
                                      style={{
                                        fontFamily: "Inter, sans-serif",
                                        color: "black",
                                      }}
                                    >
                                      Phone No :{" "}
                                      {headerData?.ContactNo
                                        ? headerData.ContactNo.replace(
                                            /(\d{3})(\d{3})(\d{4})/,
                                            "($1) $2-$3"
                                          )
                                        : ""}
                                      {/* Phone No : {item?.PhoneNumber}({item?.Email}) */}
                                    </p>
                                    <p
                                      style={{
                                        fontFamily: "Inter, sans-serif",
                                        color: "black",
                                      }}
                                    >
                                      Email: {headerData.EMail}
                                    </p>
                                    <p
                                      style={{
                                        fontFamily: "Inter, sans-serif",
                                        color: "black",
                                      }}
                                    >
                                      REP : {headerData?.rep}
                                    </p>
                                    <p
                                      style={{
                                        fontFamily: "Inter, sans-serif",
                                        color: "black",
                                      }}
                                    >
                                      Route : {headerData?.route}
                                    </p>
                                    {/* <br /> */}
                                    <p
                                      style={{
                                        fontFamily: "Inter, sans-serif",
                                        color: "black",
                                      }}
                                    >
                                      LEVEL : {headerData?.Level}
                                    </p>
                                  </>
                          </div>

                          <div className="col-md-4">
                         

                        
                                  <>
                                    
                                    <p
                                      className="text-bold mt-1"
                                      style={{
                                        fontFamily: "Inter, sans-serif",
                                        color: "black",
                                      }}
                                    >
                                      <span
                                        style={{
                                          fontWeight: "bold",
                                          color: "black",
                                        }}
                                      >
                                        Ship To:
                                      </span>{" "}
                                      <br />
                                      Company Name :{" "}
                                      {salesdetails[0]?.shippingaddress == "" ||
                                      salesdetails[0]?.shippingaddress == null
                                        ? headerData?.Companyname
                                        : salesdetails[0]?.shippingaddress}
                                    </p>

                                    {/* <br /> */}
                                    {/* <p style={{ fontFamily: "Inter, sans-serif", color:'black'}}>
                                Zipcode: {item?.Zip}
                              </p> */}
                                    {/* <p style={{ fontFamily: "Inter, sans-serif", color:'black'}}>
                                Phone No : {item?.PhoneNumber? item.PhoneNumber.replace(/(\d{3})(\d{3})(\d{4})/,"($1) $2-$3"): "N/A"}({item?.Email})
                                Phone No : {item?.PhoneNumber}({item?.Email})
                              </p> */}
                                  </>
                                

                            {/* <p style={{ fontFamily: "Inter, sans-serif",color:'black' }}>
                          shipping address:{" "}
                          {salesdetails[0]?.shippingaddress
                            ? salesdetails[0]?.shippingaddress
                            : " Same as Billing Address"}
                        </p> */}
                          </div>

                          <div className="col-md-4">
                            <div className="row">
                              <p
                                style={{
                                  alignItems: "start",
                                  fontFamily: "Inter, sans-serif",
                                  display: "flex",
                                  color: "black",
                                }}
                                className="col-md-12"
                              >
                                Invoice Date: {moment(headerData?.InvoiceDate).format(
                                  "MM/DD/YYYY h:mm A"
                                )}
                              </p>
                            </div>

                            <div className="row">
                              <p
                                className="col-md-12"
                                style={{
                                  fontFamily: "Inter, sans-serif",
                                  color: "black",
                                }}
                              >
                                Type:{" "}
                                { "Sale"
                                 }
                              </p>
                            </div>
                            {/* <hr /> */}
                            <div className="row">
                              <p
                                style={{
                                  alignItems: "start",
                                  display: "flex",
                                  fontFamily: "Inter, sans-serif",
                                  color: "black",
                                }}
                                className="col-md-12"
                              >
                                Terms:{" "}
                                {responseData?.SalesDetails &&
                                " " + responseData?.SalesDetails[0]?.termsname
                                  ? responseData?.SalesDetails[0]?.termsname
                                  : "NA"}
                              </p>
                            </div>
                            {/* <hr /> */}
                            <div className="row">
                              <p
                                style={{
                                  alignItems: "start",
                                  fontFamily: "Inter, sans-serif",
                                  display: "flex",
                                  color: "black",
                                }}
                                className="col-md-12"
                              >
                                Due Date: {salesdetails[0]?.DueDate}
                              </p>
                            </div>

                            <div className="row">
                              <p
                                style={{
                                  alignItems: "start",
                                  display: "flex",
                                  fontFamily: "Inter, sans-serif",
                                  color: "black",
                                }}
                                className="col-md-12"
                              >
                                Created Date:{" "}
                                {moment(headerData?.InvoiceDate).format(
                                  "MM/DD/YYYY h:mm A"
                                )}
                              </p>
                            </div>

                            <div className="row">
                              <p
                                className="col-md-12"
                                style={{
                                  fontFamily: "Inter, sans-serif",
                                  color: "black",
                                }}
                              >
                                Created BY : {headerData?.CustomerName}
                              </p>
                            </div>

                            <div className="row">
                              <p
                                style={{
                                  alignItems: "start",
                                  display: "flex",
                                  fontFamily: "Inter, sans-serif",
                                  color: "black",
                                }}
                                className="col-md-12"
                              >
                                Modified Date:{" "}
                                {ModifiedDate
                                  ? moment(ModifiedDate).format(
                                      "MM/DD/YYYY h:mm A"
                                    )
                                  : ""}
                              </p>
                            </div>

                            <div className="row">
                              <p
                                className="col-md-12"
                                style={{
                                  fontFamily: "Inter, sans-serif",
                                  color: "black",
                                }}
                              >
                                Modified BY : {salesdetails[0]?.ModifideName}
                                {/* Modified BY :{" "}
                            {salesdetails[0]?.ModifideName} */}
                              </p>
                            </div>
                    </div>
                        </div>
                     </div>
                    </div>
                    <hr />
                  </div>
                  {/* Body */}
                  <div className="table-responsive" id="custominvoicebody">
                    <table className="table mt-1">
                      <thead>
                        <tr>
                          <th className="col-md">S.No</th>
                          <th className="col-md-3">Description</th>

                          <th
                            className="col-md-2"
                            style={{ textAlign: "right" }}
                          >
                            Price
                          </th>
                          <th
                            className="col-md-2"
                            style={{ textAlign: "right" }}
                          >
                            Quantity
                          </th>
                          {/* <th className="col-md-2" style={{ textAlign: "right" }}>
                          Discount %
                        </th> */}
                          {/* <th className="col-md-2" style={{ textAlign: "right" }}>
                          Tax %
                        </th> */}
                          <th
                            className="col-md-2"
                            style={{ textAlign: "right" }}
                          >
                            Total
                          </th>
                          {/* <th className="col-md-2" style={{ textAlign: "right" }}>
                          Total
                        </th> */}
                        </tr>
                      </thead>

                      <tbody>
                        {itemData?.map((item, index) => {
                          return (
                            <>
                              <tr key={index}>
                                <td className="col-md">{++index}</td>

                                <td
                                  style={{ textAlign: "left" }}
                                  className="col-md-2"
                                >
                                  <small className="col-md-2">
                                    <strong>{item?.ItemName}:</strong>
                                    <strong>{item?.ItemVariationName}</strong>
                                  </small>
                                  <p>
                                    Item Number:
                                    {item.ItemNumber}
                                  </p>
                                </td>

                                <td
                                  className="col-md-2"
                                  style={{ textAlign: "right" }}
                                >
                                  ${Number(item.Price).toFixed(2)}
                                </td>

                                <td
                                  className="col-md-2"
                                  style={{ textAlign: "right" }}
                                >
                                  {Number(item.Quantity).toFixed(2)}
                                </td>

                                <td
                                  className="col-md-2"
                                  style={{ textAlign: "right" }}
                                >
                                  {Number(item.Total).toFixed(2)}
                                </td>
                              </tr>
                            </>
                          );
                        })}
                      </tbody>
                    </table>

                    <div style={{ textAlign: "right" }} className="mt-3">
                      <p style={{ margin: "0" }}>
                        <strong>Sub Total: </strong>$
                        {parseInt(headerData?.SubTotal).toLocaleString(
                          "en-US",
                          {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          }
                        )}
                      </p>
                      <p style={{ margin: "0" }}>
                        <strong>(-)Discount : </strong>$
                        {parseInt(headerData?.Discount).toFixed(2)}
                      </p>
                      <p style={{ margin: "0" }}>
                        <strong>(+)Tax : </strong>$
                        {parseInt(headerData?.Tax).toFixed(2)}
                      </p>

                      <p style={{ margin: "0" }}>
                        <strong>Total Amount: </strong>$
                        {parseInt(headerData?.Total).toFixed(2)}
                      </p>
                    </div>
                    <hr />
                  </div>

                  <div style={{ display: "none" }}>
                    <div id="customTotalfooter3">
                      <div className="row">
                        <div className="col-md-6">
                          <p style={{ margin: "0" }}>
                            <strong>Comment: </strong>
                            {salesdetails[0]?.Comment}
                          </p>
                        </div>

                        <div
                          style={{ textAlign: "right", color: "black" }}
                          className="mt-3 col-md-6"
                        >
                          <p style={{ margin: "0" }}>
                            <strong>Sub Total: </strong>${" "}
                            {Number(headerData?.SubTotal).toLocaleString(
                              "en-US",
                              {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              }
                            )}
                          </p>
                          <p style={{ margin: "0" }}>
                            <strong>Total item : </strong>
                            {Number(itemData.length).toLocaleString("en-US", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </p>
                          <p style={{ margin: "0" }}>
                            <strong>Total Qty : </strong>
                            {Number(sumss1).toLocaleString("en-US", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </p>
                          <p style={{ margin: "0" }}>
                            <strong>Total Amount: </strong>$
                            {Number(headerData?.Total).toLocaleString("en-US", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="row" id="footer">
                      <div className="row">
                        <p
                          style={{
                            marginTop: "20px",
                            textAlign: "center",
                            fontSize: "10px",
                            color: "black",
                          }}
                        >
                          BY SIGNING AND ACCEPTING THE ORDER CUSTOMER AGREES
                          THAT THE INFORMATION ABOVE IS TRUE & THEREFORE IS
                          RESPONSIBLE FOR THE ENTIRE BALANCE ON THE INVOICE. ALL
                          CREDIT MUST BE APPROVED BY THE OFFICE. NO RETURNS
                          ACCEPTED. NO RETURN/EXCHANGE ON ANY ELECTRONIC
                          CIGARETTES OR VAPE ITEMS NO EXCEPTIONS. OVER 5000+
                          CONVENIENCE STORE ITEMS GENERAL MERCHANDISE. QUICK
                          DELIVERY..LOW PRICES. THERE IS $35 BANK FEE FOR ALL
                          RETURNED CHECKS. CUSTOMER IS RESPONSIBLE FOR ALL STATE
                          AND LOCAL TAXES. SALE OF FLAVORED VAPES NOT ALLOWED IN
                          CERTAIN STATES, CUSTOMER IS RESPONSIBLE FOR ALL STATE
                          AND LOCAL COMPLIANCE RULES AND REGULATIONS.{" "}
                        </p>

                        <div
                          className="d-flex"
                          style={{
                            position: "relative",
                            justifyContent: "space-between",
                            padding: "20px",
                            color: "black",
                          }}
                        >
                          <div style={{ gap: "50px" }}>
                            <p style={{ marginTop: "30px", color: "black" }}>
                              {" "}
                              Customer Signature: ____________________________{" "}
                            </p>
                            <p style={{ marginTop: "25px", color: "black" }}>
                              {" "}
                              Date: ___________________________{" "}
                            </p>
                          </div>

                          {/* Second div aligned to the right and placed inside a box */}
                          <div
                            style={{
                              border: "1px solid black",
                              padding: "10px",
                              width: "300px",
                              position: "absolute",
                              right: "0",
                              top: "40px",
                              color: "black",
                            }}
                          >
                            <p style={{ marginTop: "10px", color: "black" }}>
                              {" "}
                              PREPARED BY: _________________________{" "}
                            </p>
                            <p style={{ marginTop: "20px", color: "black" }}>
                              {" "}
                              CHECKED BY: __________________________{" "}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div>
                {responseData.SyncDetail &&
                responseData.SyncDetail[0].SyncStatus == 0 ? (
                  <Link
                    className="btn btn-sm btn-secondary me-1 mt-5"
                    onClick={OnfliteData}
                  >
                    {` ${
                      responseData.SyncDetail &&
                      responseData.SyncDetail[0].Message
                    }`}
                  </Link>
                ) : (
                  ""
                )}
              </div>
            </>
          )}

          <div style={{ display: "none" }}>
            <div id="FullFillment">
              <div
                style={{
                  color: "#000 !important",
                  textAlign: "left !important",
                }}
              >
                <div style={{ marginTop: "0px" }} className="row">
                  <div className="col-md-6" style={{ marginLeft: "20px" }}>
                    <p
                      className="fw-bold"
                      style={{
                        fontFamily: "Inter, sans-serif",
                        fontSize: "20px",
                      }}
                    >
                      {responseData?.CompanyDetails &&
                        responseData?.CompanyDetails[0]?.CompanyName}
                    </p>{" "}
                    {/* <br /> */}
                    <p
                      style={{
                        textAlign: "left",
                        fontFamily: "Inter, sans-serif",
                        fontSize: "20px",
                      }}
                    >
                      {responseData?.CompanyDetails &&
                        responseData?.CompanyDetails[0]?.CompanyAddress}
                    </p>
                    {/* <br /> */}
                    <p
                      style={{
                        textAlign: "right",
                        fontFamily: "Inter, sans-serif",
                      }}
                    >
                      {responseData?.CompanyDetails &&
                        responseData?.CompanyDetails[0]?.Website}
                    </p>{" "}
                  </div>
                  <div className="col-md-1"></div>
                  <div className="col-md-4" style={{ textAlign: "start" }}>
                    <div
                      className="fw-bold"
                      style={{
                        fontFamily: "Inter, sans-serif",
                        fontSize: "18px",
                      }}
                    >
                      Full Fillment
                    </div>

                    <div
                      className="fw-bold"
                      style={{
                        fontFamily: "Inter, sans-serif",
                        fontSize: "16px",
                      }}
                    >
                      Sale ID - {salesdetails[0]?.Posid}
                    </div>

                    {/* <div
                          className="fw-bold"
                          style={{
                            fontFamily: "Inter, sans-serif",
                            marginTop: "2px",
                            fontSize: "10px",
                          }}
                        >
                          Balance Due
                        </div> */}

                    {/* <div
                          className="fw-bold"
                          style={{
                            fontFamily: "Inter, sans-serif",
                            fontSize: "10px",
                          }}
                        >
                          ${Number(salesdetails[0]?.Total).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                        </div> */}
                  </div>
                </div>

                <hr></hr>
                <div className="row" style={{ marginTop: "0px" }}>
                  <div style={{ marginLeft: "20px" }} className="col-md-6">
                    <p
                      style={{
                        fontFamily: "Inter, sans-serif",
                        color: "black",
                      }}
                    >
                      Bill To
                    </p>

                    {responseData?.CustomerDetails?.map((item, index) => {
                      return (
                        <>
                          <p
                            className="fw-bold mt-1"
                            style={{
                              fontFamily: "Inter, sans-serif",
                              color: "black",
                            }}
                          >
                            {item?.Name} ({item?.personid})
                          </p>
                          {/* <br /> */}
                          <p
                            style={{
                              fontFamily: "Inter, sans-serif",
                              color: "black",
                            }}
                          >
                            Company Name:{" "}
                            <b style={{ color: "black" }}>
                              {salesdetails[0]?.Posid} - {item?.Companyname}
                            </b>
                          </p>
                          {/* <br /> */}
                          <p
                            style={{
                              fontFamily: "Inter, sans-serif",
                              color: "black",
                            }}
                          >
                            Address: {item?.Address}
                          </p>
                          {/* <br /> */}
                          <p
                            style={{
                              fontFamily: "Inter, sans-serif",
                              color: "black",
                            }}
                          >
                            Country: {item?.city}
                          </p>
                          {/* <br /> */}
                          <p
                            style={{
                              fontFamily: "Inter, sans-serif",
                              color: "black",
                            }}
                          >
                            Zipcode: {item?.Zip}
                          </p>
                          <p
                            style={{
                              fontFamily: "Inter, sans-serif",
                              color: "black",
                            }}
                          >
                            Phone :
                            {item?.PhoneNumber
                              ? item.PhoneNumber.replace(
                                  /(\d{3})(\d{3})(\d{4})/,
                                  "($1) $2-$3"
                                )
                              : "N/A"}
                            {/* Phone : {item?.PhoneNumber} */}
                          </p>
                        </>
                      );
                    })}

                    {/* <p style={{ fontFamily: "Inter, sans-serif",color:'black' }}>
                          shipping address:{" "}
                          {salesdetails[0]?.shippingaddress
                            ? salesdetails[0]?.shippingaddress
                            : " Same as Billing Address"}
                        </p> */}
                  </div>

                  <div style={{ marginLeft: "20px" }} className="col-md-5">
                    <div className="row">
                      {/* <p
                            style={{
                              alignItems: "start",
                              fontFamily: "Inter, sans-serif",
                              display: "flex",
                              color:'black'
                            }}
                            className="col-md-12"
                          >
                            Invoice Date:{" "}
                            {salesdetails[0]?.Saletime
                              ? moment
                                  .tz(
                                    salesdetails[0]?.Saletime,
                                    "America/New_York"
                                  )
                                  .format("MM/DD/YYYY")
                              : ""}
                          </p> */}
                    </div>
                    {/* <hr /> */}
                    <div className="row">
                      {/* <p
                            style={{
                              alignItems: "start",
                              display: "flex",
                              fontFamily: "Inter, sans-serif",
                              color:'black'
                            }}
                            className="col-md-12"
                          >
                            Terms:{" "}
                            {responseData?.SalesDetails &&
                            " " + responseData?.SalesDetails[0]?.termsname
                              ? responseData?.SalesDetails[0]?.termsname
                              : "NA"}
                          </p> */}
                    </div>
                    {/* <hr /> */}
                    <div className="row">
                      {/* <p
                            style={{
                              alignItems: "start",
                              fontFamily: "Inter, sans-serif",
                              display: "flex",
                              color:'black'
                            }}
                            className="col-md-12"
                          >
                            Due Date:{" "}
                            {salesdetails[0]?.DueDate
                              ? moment
                                  .tz(
                                    salesdetails[0]?.DueDate,
                                    "America/New_York"
                                  )
                                  .format("MM/DD/YYYY")
                              : moment
                                  .tz(
                                    salesdetails[0]?.DueDate,
                                    "America/New_York"
                                  )
                                  .format("MM/DD/YYYY")}
                          </p> */}
                    </div>

                    <div className="row">
                      <p
                        style={{
                          alignItems: "start",
                          display: "flex",
                          fontFamily: "Inter, sans-serif",
                          color: "black",
                        }}
                        className="col-md-12"
                      >
                        Created Date:{" "}
                        {moment(createddata).format("MM/DD/YYYY h:mm A")}
                      </p>
                    </div>

                    <div className="row">
                      <p
                        className="col-md-12"
                        style={{
                          fontFamily: "Inter, sans-serif",
                          color: "black",
                        }}
                      >
                        Created BY : {salesdetails[0]?.CreatedName}
                      </p>
                    </div>

                    <div className="row">
                      <p
                        style={{
                          alignItems: "start",
                          display: "flex",
                          fontFamily: "Inter, sans-serif",
                          color: "black",
                        }}
                        className="col-md-12"
                      >
                        Modified Date:{" "}
                        {ModifiedDate
                          ? moment(ModifiedDate).format("MM/DD/YYYY h:mm A")
                          : ""}
                      </p>
                    </div>

                    <div className="row">
                      <p
                        className="col-md-12"
                        style={{
                          fontFamily: "Inter, sans-serif",
                          color: "black",
                        }}
                      >
                        Modified BY : {salesdetails[0]?.ModifideName}
                      </p>
                    </div>
                    <p
                      id="page-no"
                      style={{
                        fontFamily: "Inter, sans-serif",
                        display: "none",
                      }}
                    >
                      {/* {currentPage} */}
                      Page No : {currentPage}/{totalPages}
                    </p>
                  </div>
                </div>
              </div>
              <hr />
            </div>
          </div>
        </div>
      </div>
      <div style={{ display: "none" }}>
        {responseData.SalesItems?.map((item) => (
          <>
            <div key={item.SaleId}>
              <canvas
                data-name={item.SaleId}
                ref={(el) => (barcodeRefs.current[item.SaleId] = el)}
                id={`barcode-${item.SaleId}`}
              />
            </div>
          </>
        ))}
      </div>
    </>
  );
};

export default ShowLastSaleReceipt;

